module.exports = {
  common: {
    FindUs: 'Scoprire i nostri prodotti e servizi',

    registeredAccount: 'NTL è stato registrato',
    unlock: 'Svincolo NTL! Sperimentare il potere dell’anonimato',
    invitation: 'Invito i suoi amici a unirsi a NTL',
    closeTheDeal: 'Completamento delle prime operazioni',

    sloganthree: "Benvenuti all'NTL!",
    slogantwo: 'Esplorare l’universo unico di NTL',
    slogantwo2: 'I meccanismi sono trasparenti e sicuri',
    currencySelection: 'modulo',
    chart: 'Grafico',
    details: 'dettagli',
    entrust: 'affidare',
    login: 'Accesso',
    register: 'Iscriviti',
    loginregister: 'Accedi / Registrati',
    logout: 'Disconnettersi',
    signupnow: 'Registrati',
    tip: 'Mancia',
    indexplaceholde: 'mailbox',
    logintip: 'per favore fai prima il log in',
    expect: "Attendo con ansia l'aspettativa!",
    delete: "Confermi l'eliminazione?",
    nodata: 'Nessun dato',
    set: 'Impostato',
    update: 'Modificare',
    slogan: 'I 50 principali scambi di valuta digitale al mondo',
    subslogan: "L'agenzia statale garantisce la sicurezza dei beni",
    more: 'Di Più',
    please: 'Per favore',
    pleaseselect: 'Selezionare',
    searchplaceholder: 'Inserisci il simbolo della moneta ...',
    searchplaceholderswap: 'Inserisci il simbolo di scambio ...',
    loading: 'Caricamento in corso...',
    close: 'Vicino',
    ok: 'OK',
    fillComplete: 'Si prega di compilare le informazioni complete',
    inputpleaseselect: 'Inserisci',
    showDetail: 'Visualizza dettagli',
  },
  header: {
    index: 'Casa',
    otc: 'OTC',
    trade: 'Commercio',
    exchange: 'Exchange',
    xiaoxi: 'Messaggio',
    kefu: 'Aiuto',
    login: 'ACCESSO',
    register: 'REGISTRATI',
    asset: 'RISORSA',
    otcOrder: 'ORDINE',
    ucenter: 'ACCOUNT',
    service: 'Annuncio',
    downloadapp: "Scansiona il codice per il download e l'installazione",
    appdownlaod: 'Scarica APP',
    usercenter: 'Centro utenti',
    helpcenter: 'CENTRO ASSISTENZA',
    aboutus: 'Di',
    partner: 'Compagno',
    bzb: 'BZB ECO',
    assetmanage: 'Finanza',
    trademanage: 'Exchange',
    activity: 'Fulmine',
    lab: 'NTL Lab',
    ctc: 'C2C Exchange',
    labdetail: 'NTL Lightning Lab',
    invite: 'Partner promotore',
    whitepaper: 'Carta bianca',
    scandownload: 'Scarica app',
    innovationmanage: 'Innovazione',
    swap1: 'Swap (PRO)',
    swap2: 'Swap (Ex)',
    swap3: 'CFD',
    swap4: 'Secondo',
    cexchange: 'QuikExchange',
    option: 'Contratto di opzione',
    news: 'Notizia',
    swapExchange: 'transazione contrattuale',
    finance: 'Servizi finanziari',
    fiatCurrency: 'Acquista criptovalute',
  },
  sectionPage: {
    global_leader: 'La principale borsa monetaria digitale del mondo',
    Professional:
      'Le transazioni professionali, le operazioni semplici, vi danno un facile accesso alle transazioni digitali',

    showMore: 'Vedi di più',
    brandDesc6:
      'NTL dispone di funzione di accesso agli asset blockchain in tempo reale, tecnologia di condivisione di indirizzi multi valuta, protezione di verifica della sicurezza multipla e bassi costi di transazione e estrazione degli asset blockchain nel settore.',
    brandDesc5:
      "La soluzione tecnica di NTL si basa su Google Cloud e Amazon AWS, che previene efficacemente gli attacchi DDOS e supporta la separazione dei dati dinamici e statici; Supporta la cache dei dati caldi, il disaster recovery remoto e l'espansione parallela.",
    brandDesc4:
      'NTL attualmente dispone di servizi di asset crypto one-stop come valuta, contratto perpetuo, spot, opzione, prestito finanziario e supporta versioni linguistiche multiple come cinese/inglese/giapponese/coreano/.',
    brandTitle2: 'Servizio di crittografia one stop',
    brandDesc3:
      'NTL si impegna ad essere uno scambio internazionale di asset blockchain sicuro, stabile, conveniente, equo e affidabile degno della fiducia degli utenti e garantendo in modo completo la sicurezza delle informazioni e degli asset di trading degli utenti.',
    brandTitle1: 'Scambio internazionale di derivati su asset digitali',
    ptaqTitle: 'Platform Security',
    ptaqContent:
      "L'algoritmo hash viene utilizzato per crittografare l'autenticazione di sicurezza leader a livello mondiale",
    ptslTitle: 'Platform Strength',
    ptslContent: 'La più grande piattaforma di scambio di bitcoin al mondo',
    newsTitle: 'Centro notizie',
    brandTitle: 'Informazioni su NTL',
    brandDetail: 'Onesto | Discreto | Entusiasmo | Aperto',
    brandDesc1:
      'NTL è stata fondata da un gruppo di primi partecipanti e fanatici di Bitcoin. I membri principali del team provengono da aziende note come Google, Microsoft, Alibaba, Tencent e così via. Ha una profonda forza di ricerca e sviluppo e una ricca esperienza nel funzionamento del prodotto Internet. ',
    brandDesc2:
      "NTL si trova nel fornitore di servizi di base della catena di blocchi, dedicato a fornire una piattaforma di scambio di risorse crittografate di alta qualità per utenti globali, aderendo al principio di base di' NON ESSERE MALE ', sostenendo un servizio onesto, equo ed entusiasta ai clienti e accogliere tutti i partner / progetti che sono vantaggiosi per gli interessi fondamentali degli utenti con un atteggiamento aperto. ",
    gettingstart: 'HOT | Guida per principianti',
    officialstart: 'Servizio clienti ufficiale NTL',
    oneminutebuy: 'Transazione in valuta',
    oneminutebuytips: "Utilizza una risorsa digitale per scambiarla direttamente con un'altra",
    baseknow: 'Contratti permanenti',
    baseknowtips: 'T + 0 scambio bidirezionale di beni virtuali come contratto di baratto',
    baseexchange: 'Contratto di opzione',
    baseexchangetips: 'È un derivato di asset digitali',
    usersocial: 'Scambio rapido',
    usersocialtips: 'Scambia rapidamente risorse digitali',
    mainboard: 'Scheda principale',
    preview: 'Precedente',
    nextpage: 'Il prossimo',
    downloadwhite: 'Scarica il white paper',
  },
  nav: {
    ptjy: 'Piattaforma di trading',
    ptaq: 'Platform Security',
    ptsl: 'Forza della piattaforma',
    xwzx: 'Centro notizie',
    fabu: 'pubblicità',
  },
  progress: {
    already: 'Devo scavare',
    total: 'Quantità di minerale scavabile 6 miliardi di BHB',
  },
  service: {
    USDT: 'USDT',
    BTC: 'BTC',
    ETH: 'ETH',
    CUSTOM: 'Favore',
    COIN: 'Moneta',
    symbol: 'Coppia di transazioni',
    favor: 'Favore',
    NewPrice: 'Lastest',
    ExchangeNum: 'Quantità',
    FeePercent: 'Tasso di finanziamento',
    Change: 'Modificare',
    OpenPrice: 'Prezzo di apertura',
    PriceTrend: 'Trend dei prezzi',
    Operate: 'Aziona',
    Exchange: 'Exchange',
    trading: 'Exchange',
    high: 'Più alto',
    low: 'Inferiore',
  },
  exchange: {
    loginBuy: 'Buy After Login (BTC)',
    loginOut: 'Vendi dopo il login (BTC)',
    coin: 'Moneta',
    symbol: 'Coppia di transazioni',
    lastprice: 'Lastest',
    daychange: 'Modificare',
    market: 'Mercati',
    favorite: 'Contrassegnato',
    do_favorite: 'Raccolti',
    cancel_favorite: 'Annulla raccolta',
    type: 'Genere',
    dealamount: 'Importo finale',
    high: 'Alto',
    low: 'Basso',
    vol: 'Vol 24 ore',
    buy: 'Acquista',
    sell: 'Vendere',
    limited_price: 'Prezzo limitato',
    market_price: 'Prezzo di mercato',
    fees_rate: 'tasso di commissione',
    balance: 'saldi',
    or: 'o',
    starttrade: 'Negozia ora!',
    canuse: 'A disposizione',
    recharge: 'Deposito',
    buyprice: 'Prezzo di acquisto',
    buynum: 'Importo acquisto',
    amount: 'Quantità',
    buyin: 'Acquista',
    disablebuyin: 'Market Buy disabilitato',
    buytip: 'Acquisto ottimale',
    sellprice: 'Prezzo di vendita',
    sellnum: 'Importo di vendita',
    sellout: 'Vendere',
    disablesellout: 'Vendita di mercato disattivata',
    selltip: 'Vendita ottimale',
    curdelegation: 'Delegato',
    hisdelegation: 'Delegato della storia',
    realtransaction: 'Operazioni di mercato',
    num: 'Quantità',
    price: 'Prezzo',
    direction: 'Direzione',
    time: 'Tempo',
    stall: 'Stalla',
    total: 'Totale',
    traded: 'Fatto',
    action: 'Azione',
    undo: 'Disfare',
    delegationnum: 'Delegate Amount',
    done: 'Fatto',
    status: 'Stato',
    finished: 'Finito',
    canceled: 'Annullato',
    parted: 'Parted',
    tip: 'Mancia',
    buyamounttip: "inserisci l'importo dell'acquisto",
    buyamounttipwarning: 'acquista importo non di più',
    success: 'presentare successo!',
    pricetip: 'inserisci prezzo di acquisto',
    pricetipwarning: 'prezzo di acquisto non di più',
    sellamounttip: "inserisci l'importo di vendita",
    sellamounttipwarning: "vendere l'importo non di più",
    sellpricetip: 'inserisci prezzo di vendita',
    sellpricetipwarning: 'prezzo di vendita non di più',
    undotip: 'Conferma annullamento?',
    cancelsuccess: 'Annulla ordine riuscito',
    marketprice: 'Prezzo di mercato',
    expand: {
      time: 'tempo',
      price: 'prezzo',
      amount: 'quantità',
      fee: 'commissione',
    },
    realtime: 'tempo reale',
    kline: 'KLine',
    depth: 'Profondità',
    publishstate0: 'Sta per iniziare. Attendi ...',
    publishstate1: 'Sta per finire. Attendi ...',
    publishstate2: 'Consolidamento ordini, attendere prego ...',
    publishstate3: 'Il consolidamento è terminato, per favore commercia gratuitamente ....',
    publishdetail: 'Più dettagli',
    publishprice: 'Prezzo',
    publishamount: 'Quantità',
    publishcounttxt0: 'Inizia dopo',
    publishcounttxt1: 'Fine dopo',
    publishcounttxt2: 'Libero scambio dopo',
    publishcounttxt3: 'Attività finita!',
    dateTimeDay: 'D',
    dateTimeHour: 'H',
    dateTimeMinutes: 'M',
    dateTimeSeconds: 'S',
    moredetail: 'Visualizza altro',
  },
  swap: {
    contract: 'Contratto',
    swapindex: 'SWAP',
    coin: 'Moneta',
    symbol: 'Coin Pair',
    volume: 'Volume',
    lastprice: 'Lastest',
    daychange: 'Modificare',
    market: 'Mercati',
    favorite: 'Contrassegnato',
    do_favorite: 'Raccolti',
    cancel_favorite: 'Annulla raccolta',
    type: 'Genere',
    dealamount: 'Importo finale',
    high: 'Alto',
    low: 'Basso',
    vol: 'Vol 24 ore',
    buy: 'Acquista',
    sell: 'Vendere',
    limited_price: 'Prezzo limitato',
    market_price: 'Prezzo di mercato',
    spot_price: 'Prezzo trigger',
    fees_rate: 'tasso di commissione',
    balance: 'saldi',
    or: 'o',
    starttrade: 'Negozia ora!',
    canuse: 'A disposizione',
    recharge: 'Deposito',
    buyprice: 'Prezzo di acquisto',
    buynum: 'Importo acquisto',
    amount: 'Quantità',
    buyin: 'Acquista',
    disablebuyin: 'Market Buy disabilitato',
    buytip: 'Acquisto ottimale',
    sellprice: 'Prezzo di vendita',
    sellnum: 'Importo di vendita',
    sellout: 'Vendere',
    disablesellout: 'Vendita di mercato disattivata',
    selltip: 'Vendita ottimale',
    curdelegation: 'Delegato',
    hisdelegation: 'Delegato della storia',
    realtransaction: 'Operazioni di mercato',
    num: 'Quantità',
    price: 'Prezzo',
    direction: 'Direzione',
    time: 'Tempo',
    stall: 'Stalla',
    total: 'Totale',
    traded: 'Fatto',
    action: 'Azione',
    undo: 'Disfare',
    delegationnum: 'Delegate Amount',
    done: 'Fatto',
    status: 'Stato',
    finished: 'Finito',
    canceled: 'Annullato',
    parted: 'Parted',
    tip: 'Mancia',
    buyamounttip: "inserisci l'importo dell'acquisto",
    buyamounttipwarning: 'acquista importo non di più',
    success: 'presentare successo!',
    pricetip: 'inserisci prezzo di acquisto',
    pricetipwarning: 'prezzo di acquisto non di più',
    sellamounttip: "inserisci l'importo di vendita",
    sellamounttipwarning: "vendere l'importo non di più",
    sellpricetip: 'inserisci prezzo di vendita',
    sellpricetipwarning: 'prezzo di vendita non di più',
    undotip: 'Conferma annullamento?',
    cancelsuccess: 'Annulla ordine riuscito',
    marketprice: 'Prezzo di mercato',
    expand: {
      time: 'tempo',
      price: 'prezzo',
      amount: 'quantità',
      fee: 'commissione',
    },
    realtime: 'tempo reale',
    kline: 'KLine',
    depth: 'Profondità',
    open: 'Aperto',
    close: 'Vicino',
    latestdeal: 'Ultimo affare',
    myswapaccount: 'Il mio account di swap',
    accountmode: 'Pattren',
    accountmargin: 'Leva',
    accountquanyi: 'Equità',
    profitandloss: 'P / L non realizzato',
    principalAmount: 'Margine disp.',
    positionAmount: 'Margine utilizzato',
    frozenAmount: 'Margine congelato',
    principalRate: 'Rapporto margine',
    zijinhuazhuan: 'Trasferimento',
    up: 'L',
    down: 'S',
    canup: 'Max. L',
    candown: 'Max. S',
    cancloseup: 'Max (S)',
    canclosedown: 'Max (L)',
    openup: 'Open Long',
    opendown: 'Open Short',
    closeup: 'Chiudi breve',
    closedown: 'Close Long',
    currentposition: 'Posizioni aperte',
    assetsdetail: 'Transazioni',
    marginMode1: 'Fisso',
    marginMode2: 'Croce',
    modifyMarginModeTitle: 'Modifica modalità margine conto',
    modifyLeverage: 'Modifica leva',
    moredetail: 'Visualizza altro',
    shareNumber: 'Cont',
    entrustprice: 'Prezzo',
    triggleprice: 'Trigger',
    openvolume: 'Volume lungo',
    closevolume: 'Volume breve',
    triggleplaceholder: 'Il prezzo predefinito è di mercato',
    marketpriceplaceholder: 'Negozia al miglior prezzo',
    levmaxtip: 'La leva finanziaria non deve superare il massimo',
    levmintip: 'La leva non deve essere inferiore al Min',
    marginModeSuccessTip: 'Modifica successo.',
    noenoughbalance: 'Equilibrio insufficiente',
    pleaseinputopenvolume: 'Il volume deve essere superiore a 0',
    pleaseinputcorrectopenvolume: 'Inserisci il volume corretto',
    pleaseinputrightentrustprice: 'Inserisci il prezzo corretto',
    noenoughposition: 'Posizione insufficiente',
    pleaseinputclosevolume: 'Il volume deve essere superiore a 0',
    pleaseinputcorrectclosevolume: 'Inserisci il volume corretto',
    pos_Pl: 'PL.',
    pos_Ratio: 'Rapporto PL',
    pos_pos: 'Posizione',
    pos_canClose: 'Posizione Ava',
    pos_openPrice: 'Prezzo di apertura',
    pos_leverage: 'Leva',
    pos_margin: 'Cur Margin',
    pos_mRatio: 'Rapporto margine',
    pos_cmRatio: 'Rapporto di manutenzione',
    pos_long: 'Lungo',
    pos_short: 'Corto',
    ent_entrustType: 'Aperto chiuso',
    ent_direction: 'Direzione',
    ent_type: 'Genere',
    ent_trigglePrice: 'Prezzo trigger',
    ent_entrustPrice: 'Affust Price',
    ent_tradedPrice: 'Prezzo negoziato',
    ent_margin: 'Margine',
    ent_volume: 'Volume',
    ent_status: 'Stato',
    ent_status1: 'Affidare',
    ent_status2: 'Annullato',
    ent_status3: 'Affidamento fallito',
    ent_status4: 'Traded',
    ent_statusblast: 'Blast',
    ent_pl: 'P / L',
    ent_fee: 'Commissione',
    triggerpriceshouldbigger: 'Il prezzo di attivazione deve essere superiore a 0',
  },
  second: {
    balance: 'Equilibrio',
    profitability: 'Redditività',
    opentime: 'Tempo aperto',
    transactionMode: 'Modalità di transazione',
    currentPosition: 'Posizione attuale',
  },
  ctc: {
    title: 'Vendita con un clic ● Garanzia della piattaforma ● Sicurezza',
    desc: "Le risorse crittografiche sono gestite da NTL e l'accettatore fornisce servizi di scambio per lo scambio.",
    buyin: 'Acquista',
    sell: 'Vendere',
    buyprice: 'Prezzo di acquisto',
    sellprice: 'Prezzo di vendita',
    buynum: 'Importo acquisto',
    sellnum: 'Importo di vendita',
    payamount: 'Pagamento',
    getamount: 'Pagamento',
    avabalance: 'A disposizione',
    time: 'Data di negoziazione',
    tip: 'Avviso',
    notice: 'Avviso',
    notice1:
      "1. L'area di scambio di valuta legale è una transazione di attività tra utenti e accettatori. I fondi non vengono trasferiti su una piattaforma e la piattaforma non accetta ricariche / rimesse di RMB ；",
    notice2:
      '2. Gli accettatori di transazioni in valuta legale hanno superato la certificazione del nome reale, offrendo margini di transazione e i token sono ospitati dalla piattaforma, quindi puoi essere certo che possono essere convertiti ；',
    notice3:
      "3. L'orario di servizio dell'accettazione è dalle 09:00 alle 21:00 al giorno. L'accettazione viene completata entro 30 minuti dall'accettazione dell'ordine e la transazione non completata di due ore viene annullata ；",
    notice4:
      "4. Per supportare le carte bancarie nell'area di scambio di valuta legale, è necessario trasferire fondi utilizzando un conto che hai autenticato con il tuo vero nome ；",
    notice5:
      "5. Al fine di garantire la sicurezza dei fondi delle transazioni, la transazione in valuta legale richiede agli utenti di passare l'autenticazione con il nome reale ；",
    payType: 'Conto di pagamento',
    receiveType: 'Ricevi account',
    moneyTips:
      "Il prezzo di cui sopra è solo di riferimento. Fare riferimento all'importo effettivo del saldo dopo il seguente ordine.",
    verifyset: 'RealName / Asset Password',
    payset: 'Impostazioni pagamento',
    trade: 'Exchange',
    input50tips: 'Immettere un numero compreso tra 50 e 50.000',
    bank: 'Carta di credito',
    alipay: 'Alipay',
    wechatpay: 'Wechat',
    payaccountset: 'Impostazioni account di pagamento',
    useselfaccount: 'Assicurati di utilizzare il tuo account autenticato con nome reale.',
    orderSn: "Numero d'ordine.",
    tradetime: 'Data di cambio',
    direction: 'Direzione',
    amount: 'Importo (USDT)',
    money: 'Totale (CNY)',
    price: 'Prezzo (CNY)',
    status: 'Stato',
    operate: 'Aziona',
    moredetail: 'Più dettagli',
  },
  cexchange: {
    use: 'consumare',
    consume: 'scambio',
    title: 'Conversione rapida',
    desc: 'Un clic,Guadagna ogni giorno',
    quantity: 'ActivityPurchase Quantity',
    inputtips1: 'Il numero di personalizzato',
    choosecurrency: 'Scegli una valuta',
    maxtip: 'Riscatto massimo ',
    mintip: 'scambio minimo ',
    all: 'Tutti',
    totalpay: 'Importo in valuta pagato',
    restricted: 'Il totale limitato oggi',
    currentprice: 'Prezzo attuale',
    nextprice: 'Prezzo del prossimo numero',
    confirmpay: 'Conferma pagamento',
    assets: 'saldo:',
    loginFirst: 'Accedete, per favore',
    success: 'Congratulazioni, scambio riuscito!',
    tip: 'Suggerimenti',
    confirm: 'Conferma suggerimenti',
    confirmmsg: 'Sei sicuro di scambiare BZB?',
    ok: 'OK',
    cancel: 'Annulla',
  },
  option: {
    title: 'Contratto di opzione',
    buyupreward: 'Acquista montepremi',
    buydownreward: 'Vendi montepremi',
    quantity: 'Importo scommessa',
    myamount: 'Importo della mia scommessa',
    buyup: 'Price Up',
    buydown: 'Price Down',
    history: 'Storia',
    seriers: 'No.',
    period: '',
    currentoption: 'Intervallo di tempo',
    openprice: 'Prezzo di apertura',
    currentprice: 'Prezzo corrente',
    openprice1: 'Prezzo di apertura',
    closeprice: 'Prezzo di chiusura',
    opentime: 'Tempo aperto',
    closetime: 'Close Time',
    progress: 'Progresso',
    loginFirst: 'Per favore fai prima il log in!',
    selectAmount: "Seleziona l'importo",
    balancenotenough: 'Banlance non basta!',
    betsuccess: 'Congratulazioni！ Scommetto con successo！',
    noopening: 'Nessuna apertura adesso!',
    col_createTime: 'Crea ora',
    col_direction: 'Direzione',
    col_result: 'Risultato',
    col_optionNo: 'No.',
    col_betAmount: 'Importo scommessa',
    col_rewardAmount: 'Importo del premio',
    col_fee: 'Tariffa aperta',
    col_winfee: 'Commissione premio',
    win: 'Win',
    lose: 'Perdi',
    wait: 'Apertura',
    avaliablebalance: 'Saldo disponibile',
    login: 'Accedete, per favore',
    kline: 'música',
  },
  otc: {
    payment_detail: 'Dettagli metodo di pagamento',
    bind_payment: 'Lega il metodo di pagamento',
    payment_placeholder: 'Seleziona un metodo di pagamento',
    payment: 'Metodo di pagamento',
    ad: 'Pubblicità',
    buyin: 'Acquista',
    sellout: 'Vendere',
    merchant: 'Mercante',
    applymerchant: 'Applica commerciante',
    volume: 'Volume',
    paymethod: 'Metodo di pagamento',
    amount: 'Quantità',
    price_coin: 'Prezzo / moneta',
    operate: 'Azione',
    validate: 'Per favore prima verifica',
    sell: 'vendere',
    buy: 'acquista',
    transaction: 'Transazioni commerciali',
    buttontxt: 'Diventa commerciante',
    title: 'Borsa OTC',
    desc: 'Vendita conveniente, sicura e veloce di valuta digitale',
    title1: 'Regolazione dinamica',
    desc1: 'Fluttuazione in tempo reale in base al prezzo di mercato',
    title2: 'Senza costi',
    desc2:
      'Quello che vedi è quello che ottieni. Oltre al prezzo di vendita, non ci sono costi di servizio per la piattaforma',
    title3: 'Transazione immediata',
    desc3:
      "L'introduzione di servizi di piattaforma per i commercianti, abbinamento intelligente, chiusura degli ordini, non è necessario attendere il matchmaking",
    title4: 'Garanzia piattaforma',
    desc4:
      'Attività di certificazione della piattaforma, sicurezza garantita, servizio clienti 24 ore su 24 per la scorta della transazione',
    myad: {
      title: 'Il mio annuncio',
      post: 'Pubblica un annuncio',
      alert:
        "【Suggerimento】 ： Quando l'importo minimo degli acquisti pubblicitari più la tariffa è maggiore del numero rimanente di annunci, l'annuncio viene automaticamente tolto dallo scaffale.",
      no: 'no',
      type: 'genere',
      sell: 'vendere',
      buy: 'acquista',
      limit: 'limite',
      remain: 'importo rimanente',
      coin: 'moneta',
      created: 'Data di Creazione',
      operate: 'azione',
      errmsg: "Può essere modificato e modificato dopo che l'annuncio è inattivo",
      update: 'modificare',
      shelf: 'mensola',
      dropoff: 'dropoff',
      delete: 'Elimina',
    },
    myorder: 'Il mio ordine',
    chatline: {
      status_1: "L'acquirente non ha pagato e ha aspettato che l'acquirente pagasse！",
      status_2: "L'acquirente ha pagato e attende che il venditore rilasci！",
      status_3: 'Transazione ordine completata！',
      status_4: "L'ordine è oggetto di ricorso！",
      status_5: 'Ordine cancellato!',
      loadmore: 'Carica altro',
      warning:
        'Avvisi antifrode: nel recente passato, i truffatori hanno utilizzato ripetutamente informazioni sulle rimesse di bonifici bancari e false credenziali di rimesse per attività fraudolenta, quindi assicurati di controllare il numero del tuo conto di pagamento. Garantisci la sicurezza dei fondi delle rimesse ed evita il rischio di carte bancarie congelate！ ',
      contenttip: 'Inserisci il contenuto della chat Inserisci la chiave per inviare',
      contentmsg: 'Il messaggio non può essere vuoto',
    },
    chat: {
      seller: 'Venditore',
      buyer: 'Acquirente',
      exchangeamount: 'Importo dello scambio',
      operatetip: 'Aziona punta',
      operatetip_1:
        "Completa il pagamento in conformità con l'account fornito dall'altra parte entro il limite di tempo e fai clic su questa pagina.",
      finishpayment: 'pagamento completato',
      operatetip_1_1:
        'Si prega di notare nei commenti quando si trasferisce il buon numero di riferimento del pagamento',
      operatetip_1_2:
        'Dopo aver ricevuto il pagamento, il venditore confermerà il pagamento sul sito web. Il sistema invierà automaticamente le risorse digitali che hai acquistato al tuo account. Tieni presente che',
      note: 'Nota',
      notetip:
        'Si prega di non utilizzare altri software di chat per comunicare tra loro e di non accettare documenti, allegati di posta elettronica, ecc. Inviati dalla direzione. Tutti i collegamenti di comunicazione sono completati nella finestra di chat in questa pagina.',
      operatetip_2_1:
        "Le risorse digitali che hai venduto sono state inviate alla piattaforma per l'hosting e il congelamento. Hai confermato il pagamento, fai clic su",
      operatetip_2_2:
        'Per favore non credere a nessuna ragione per sollecitare il rilascio della valuta, confermare la ricezione del denaro e rilasciare le risorse digitali per evitare perdite！',
      operatetip_2_3:
        "Dopo aver ricevuto il messaggio breve dell'account, assicurati di accedere all'online banking o al mobile banking per confermare se il pagamento è contabilizzato, per evitare il falso rilascio di risorse digitali dovuto alla ricezione di messaggi fraudolenti！",
      confirmrelease: 'Conferma rilascio',
      paydigital: 'Paga risorse digitali',
      orderstatus: "Stato dell'ordine",
      orderstatus_1: 'pagamento completato',
      orderstatus_2: 'Order appeal',
      orderstatus_3: 'Conferma rilascio',
      orderstatus_4: 'annulla il contratto',
      orderstatus_5: 'Order appeal',
      order: 'Ordine',
      and: 'e',
      transition: 'scambio',
      transprice: 'Prezzo di negoziazione',
      transnum: 'Numero negoziazione',
      transmoney: 'Importo di negoziazione',
      tip1: "L'utente non ha ancora aggiunto il numero della carta di credito",
      tip2: "L'utente non ha aggiunto l'account Alipay per il momento",
      tip3: "L'utente non ha ancora aggiunto l'account WeChat",
      zfb: 'Alipay',
      wx: 'WeChat',
      qrcode: 'QR Code',
      msg1: 'Sei sicuro di aver pagato?',
      msg2: "I pagamenti non sono rimborsabili! Annullare l'ordine?",
      msg3: "【Ripeti】 ： I pagamenti non sono rimborsabili! Annullare l'ordine?",
      msg4: 'Pagato, non ricevuto',
      msg5: 'Già pagato, non ricevuto',
      tip: 'Mancia',
      comptype: 'Tipo di reclamo',
      compremark: 'Nota di reclamo',
      willcomp: 'Voglio lamentarmi',
      msg6: 'Confermi il rilascio di valuta?',
      result_1: 'aspettando il pagamento',
      result_2: 'In attesa di rilascio',
      result_3: 'Completato',
      result_4: 'Attraente',
      result_5: 'Annullato',
      msg7: 'Password fondo',
      msg7tip: 'inserisci la password del fondo',
    },
    checkuser: {
      emaildone: 'Email certificata',
      emailundo: 'Email non autorizzata',
      teldone: 'Certificato Telno',
      telundo: 'Telno non autorizzato',
      idcarddone: 'Certificato IDCard',
      idcardundo: 'IDCard non autorizzata',
      language: 'linguaggio',
      languagetext1: 'English',
      languagetext: 'Cinese',
      registtime: 'Ora di registrazione',
      exchangetimes: 'Transazioni accumulate',
      exchangeinfo: 'Informazioni di trading',
      tablabel1: 'Vendi online',
      tablabel2: 'Comprare on line',
      col_symbol: 'Moneta',
      col_paymode: 'Metodo di pagamento',
      col_num: 'Quantità',
      col_price: 'Prezzo',
      col_created: 'Tempo di rilascio',
      col_operate: 'Aziona',
      operatemsg: "Eseguire prima l'autenticazione del nome reale",
      buyin: 'Consenso',
      sellout: 'Tutto esaurito',
    },
    tradecenter: {
      postad: 'Pubblica un annuncio',
      exchange: 'Transazione GCC',
      buyin: 'Voglio acquistare',
      sellout: 'Voglio tutto esaurito',
    },
    tradeinfo: {
      emaildone: 'Email certificata',
      emailundo: 'Email non autorizzata',
      teldone: 'Certificato Telno',
      telundo: 'Telno non autorizzato',
      idcarddone: 'Certificato IDCard',
      idcardundo: 'IDCard non autorizzata',
      exchangetimes: 'Orari di cambio',
      price: 'Prezzo',
      num: 'Quantità',
      paymethod: 'PayMethod',
      exchangelimitamount: 'Limite di scambio',
      location: 'Posizione',
      location_text: 'Cina',
      exchangeperiod: 'Periodo di scambio',
      minute: 'min',
      amounttip: "Inserisci l'importo",
      numtip: 'Immettere il numero',
      remarktip: 'Digli la tua richiesta',
      remarktitle: 'Horizon Remarks',
      exchangetitle: 'Informazioni di trading',
      exchange_tip1:
        "Dopo aver avviato la richiesta di transazione, la valuta digitale viene bloccata nell'hosting e protetta dalla piattaforma. Se sei un venditore, dopo aver avviato una richiesta di transazione, puoi ricaricare e attendere che l'acquirente paghi. Gli acquirenti pagano entro il termine di pagamento. Dopo aver ricevuto il pagamento, devi rilasciare la valuta digitale che è sotto la tua custodia. ",
      exchange_tip2:
        'Leggere prima di fare trading 《Termini di servizio di Platform Network》 e domande frequenti, guide di trading e altra documentazione di aiuto.',
      exchange_tip3:
        "Attenzione al bugiardo! Prima della transazione, controlla la valutazione ricevuta dall'utente e presta maggiore attenzione all'account appena creato.",
      exchange_tip4:
        "Nota ， L'arrotondamento e le fluttuazioni dei prezzi possono influire sulla quantità di valuta digitale che viene eventualmente scambiata. L'importo fisso immesso determina l'importo finale e l'importo della valuta digitale verrà calcolato dal tasso di cambio istantaneo nello stesso momento in cui richiesta viene emessa. ",
      exchange_tip5:
        'I servizi di hosting proteggono sia gli acquirenti che i venditori di transazioni online. In caso di controversia, valuteremo tutte le informazioni fornite e rilasceremo la valuta digitale ospitata al suo proprietario legale.',
      warning1: 'Inserisci fino a 2 cifre decimali',
      warning2: "L'importo dell'ordine è",
      warning3: 'Immettere fino a 8 cifre decimali',
      warning4: "La quantità dell'ordine è",
      confirmbuyin: 'Conferma acquisto',
      confirmsellout: 'Conferma vendita',
      buyin: 'Consenso',
      sellout: 'Tutto esaurito',
      warning5: "Si prega di compilare l'ordine come richiesto",
    },
    publishad: {
      createad: "Crea un'offerta pubblicitaria",
      msg1: 'Se fai spesso trading, puoi creare il tuo annuncio di trading. Se fai trading solo occasionalmente, ti consigliamo di cercare direttamente',
      msg2: 'Creare un annuncio di trading è',
      msg3: 'Gratuito',
      msg4: 'Se desideri modificare direttamente gli annunci creati, controlla',
      tradead: 'Pubblicità commerciale',
      myad: 'La mia pubblicità',
      iwant: 'Voglio',
      sellonline: 'vendi online',
      buyonline: 'comprare on line',
      exchangecoin: 'Exchange Coin',
      country: 'Nazione',
      currency: 'Moneta',
      openfixedprice: 'Prezzo fisso aperto',
      open: 'Aperto',
      close: 'Vicino',
      usetip:
        'Se abilitato, il prezzo della valuta non fluttuerà con il mercato e il prezzo non cambierà.',
      premiseprice: 'Premium',
      premisepricetip: 'Imposta il tuo premio',
      fixedprice: 'prezzo fisso',
      fixedpricetip: 'Inserisci il tuo prezzo di cambio',
      marketprice: 'Prezzo di riferimento di mercato',
      marketpricetip:
        'Il premio si riferisce a quale percentuale è superiore al prezzo di mercato corrente',
      exchangeprice: 'Prezzo di borsa',
      formual: 'Formula dei prezzi',
      num: 'Quantità',
      num_text1: 'Inserisci quello che vuoi',
      num_text2: 'num',
      exchangeperiod: 'Periodo di transazione',
      exchangeperiod_text1: 'Inserisci la tua scadenza di negoziazione',
      minute: 'min',
      tip1: "Per quanto tempo l'acquirente può accettare transazioni, inserisci un numero intero",
      tip2: '【Suggerimento】 Può essere associato al centro personale / Aggiungi metodo di pagamento',
      tip3: "Inserisci l'importo minimo della transazione",
      tip4: "Inserisci l'importo massimo della transazione",
      tip5: "Puoi inserire i tuoi requisiti speciali nelle informazioni sui commenti, ad esempio: requisiti dell'acquirente, tempo online e così via.",
      paymode: 'Metodo di pagamento',
      minlimit: 'Importo minimo della transazione',
      maxlimit: 'Importo massimo della transazione',
      remark: 'Osservazioni',
      openautoreply: 'Apri risposta automatica',
      msg5: "Se abilitato, quando l'utente avvia una transazione tramite questo annuncio, il sistema invia automaticamente la frase di risposta automatica selezionata all'altra parte.",
      autoreply: 'Risposta automatica',
      autoreplytip:
        "Dopo aver ricevuto l'ordine, le informazioni vengono automaticamente restituite all'acquirente, ad esempio: metodo di pagamento, numero del conto di raccolta, ecc.",
      fundpwd: 'Password fondo',
      fundpwdtip: 'Inserisci la password dei tuoi fondi',
      submit: 'Invia',
      warning1: 'Inserisci il numero corretto',
      warning2: 'Il valore di overflow è 0-20',
      warning3: "Inserisci l'importo massimo della transazione!",
      warning4: 'Inserisci un numero intero',
      warning5:
        "L'importo massimo della transazione deve essere maggiore dell'importo minimo della transazione!",
      warning6:
        "L'importo massimo della transazione non può superare l'importo totale della vendita",
      warning7: "Inserisci l'importo minimo della transazione!",
      warning8: "L'importo minimo della transazione deve essere maggiore o uguale a 100!",
      warning9:
        "L'importo minimo della transazione deve essere inferiore all'importo massimo della transazione",
      sellout: 'Vendere',
      buyin: 'Acquista',
      inputtip1: 'Inserisci la valuta',
      inputtip2: "Inserisci l'opzione corretta",
      inputtip3: 'Il valore di overflow è 0-20 e non può essere 0',
      inputtip4: 'Inserisci il prezzo fisso corretto',
      inputtip5: 'Inserisci il numero corretto e il numero massimo di transazioni non supera 100',
      inputtip6: 'Inserisci la scadenza di negoziazione corretta',
      inputtip7: 'Seleziona il metodo di transazione',
      inputtip8: 'Inserisci la password dei fondi',
      zfb: 'Alipay',
      wx: 'Wechat',
      unionpay: 'BankCard',
      submit_failure: 'Fallimento!',
      submittip1: 'Procedi con una serie di certificazioni come nomi reali',
      submittip2: 'Esegui una serie di certificazioni come i telefoni cellulari',
      submittip3: 'Procedi con una serie di certificazioni come le password maiuscole',
      submittip4: 'Associa almeno un metodo di pagamento',
    },
    index: {
      title: 'Buon consiglio pubblicitario',
      exchangetimes: 'Tempi di transazione',
      exchangeprice: 'Prezzo della transazione',
      exchangelimit: 'Limite di transazione',
      paymode: 'Metodo di pagamento',
      buy: 'acquista',
      sell: 'vendere',
      viewmore: 'Di Più',
      bot1: 'Sicuro e affidabile',
      bot1_tip:
        'Più di 10 anni di esperienza nel team di controllo dei rischi finanziari  nSistema di criteri di sicurezza personalizzabile',
      bot2: 'Facile e veloce',
      bot2_tip:
        'Supporto modalità transazione gratuita per utenti peer-to-peer  nTipi di canali di scambio di denaro',
      bot3: 'Valuta completa',
      bot3_tip:
        'Selezione delle principali valute delle transazioni di asset digitali  nEsperienza di trading multi-asset',
      ibuy: 'Voglio comprare',
      isell: 'Voglio vendere',
    },
  },
  activity: {
    all: 'Tutti',
    prepare: 'In arrivo',
    ongoing: 'In corso',
    distributing: 'Distribuzione',
    completed: 'Completato',
    progress: 'Progresso',
    totalsupply: 'Offerta totale',
    starttime: "Data d'inizio",
    endtime: 'Data di fine',
    viewdetail: 'Dettaglio',
    attend: 'Assistere',
    tokendistribute: 'Distribuzione di token',
    baseinfo: "Informazioni sull'attività",
    status: 'Stato',
    activitytype: 'Tipo di attività',
    activitytype0: 'Unkonwn',
    activitytype1: 'Elenco (FOF)',
    activitytype2: 'Elenco (AVA)',
    activitytype3: 'HolderDivide',
    activitytype4: 'FreeBuy',
    activitytype5: 'MiningBuy',
    activitytype6: 'Bloccato',
    ruledetail: 'Informazioni sulla regola',
    publishprice: 'Prezzo pubblicazione',
    activitycoin: 'Simbolo moneta attività',
    accpetcoin: 'Accetta simbolo moneta',
    holdcoin: 'Hold Coin Symbol',
    limittimes: 'Tempi limite personali',
    limitamount: 'Importo limite personale',
    unlimited: 'Illimitato',
    alreadyamount: 'Importo già venduto',
    leftamount: 'Quantità rimanente',
    attention: 'Attenzione',
    attentiontxt1:
      "1 、 Le risorse verranno congelate dopo l'invio per la partecipazione alle attività di tipo [partizione del magazzino] e [abbonamento gratuito] fino al completamento dello scongelamento.",
    attentiontxt2:
      "2 、 Gli utenti non possono ritirare la loro domanda di partecipazione dopo aver partecipato alle attività del tipo 'Holder Divide' e 'Fress Buy'",
    attentiontxt3:
      "3 、 Se l'attività viene annullata a causa della parte del progetto e di altri fattori di forza maggiore, il percorso originale deve essere restituito ai beni congelati.",
    attentiontxt4:
      '* Il diritto di interpretazione finale di questa attività appartiene alla proprietà ufficiale di NTL.',
    inputamount: 'Quantità di input',
    inputholdamount: 'Importo blocco input',
    mybalance: 'Saldo disponibile',
    holdtips: "[HolderDivide] richiede il blocco fino alla fine dell'attività.",
    pleaseinputamount: "Inserisci l'importo!",
    pleaseinputholdamount: "Inserisci l'importo trattenuto!",
    commitfailed: 'Commit Failed！',
    minlimitamountfailed:
      "La quantità di scambio non deve essere inferiore all'importo minimo minimo di scambio.！",
    maxlimitamountfailed:
      "L'importo dello scambio non deve essere superiore all'importo massimo di acquisto.！",
    limittimesfailed: 'Hai partecipato a più del numero massimo di acquisti individuali.！',
    balancenotenough: "L'equilibrio non è sufficiente！",
    headertitledesc:
      'Laboratori aperti per una cooperazione vantaggiosa per tutti tra investitori, proiettori e scambi',
    currentdivided: 'La mia posizione attuale verrà',
    leveloneCount: 'Limit Level One Count',
    submit: 'Invia',
    tipsmobile: 'Si prega di utilizzare PC web （ntlex.com）',
    tipsmobile1: 'Puoi accedere al Web del PC per partecipare a questa attività.',
    intvalue: 'Inserisci il valore int',
    inputminingamount: 'Input Buy Count',
    moreactivity: 'Altre attività',
    releaseType: 'Tipo di rilascio',
    releaseType0: 'Uguale rilascio',
    releaseType1: 'Rilascio isometrico',
    lock: 'Serratura ',
    releaseDetail: 'Dettaglio rilascio',
    lockday: 'Giorni',
    lockweek: 'Settimane',
    lockmonth: 'Mesi',
    lockyear: ' Anni',
    releasePercent: 'Percentuale di rilascio',
    lockFee: 'Tassa di blocco',
    releaseTimes: 'Release Times',
    times: 'volte',
  },
  invite: {
    inviteLoginName: 'Accedi come partner',
    chengwei: 'Ricevere la più alta opportunità di tornare al servizio domestico per tutta la vita',
    pthhr: 'Diventa partner di piattaforma',
    partnerText:
      'Invita gli amici a registrarsi e autenticarsi con i loro nomi reali per godere dei dividendi della piattaforma',
    myinvitelink: 'Link promozione',
    copy: 'Copia',
    copyed: 'Copiato',
    mylevelone: 'Amici di livello uno',
    myleveltwo: 'Livello due amici',
    mycommission: 'Reddito da commissione (USDT)',
    extrareward: 'Ricompense aggiuntive',
    partnerlevel: 'Livello di partnership',
    ruledetail: 'Dettagli regola',
    ruleprofile1:
      "[Promotion Partner] è la percentuale più alta di ritorno della Commissione online e il tempo più lungo di ritorno della commissione (commissione massima a vita). I promotori che compiono sforzi corrispondenti possono diventare veri 'partner' della piattaforma e godere del dividendo di crescere insieme alla piattaforma di trading NTL . Le regole dettagliate sono le seguenti: ",
    ruleprofile2: '',
    ruleprofile3: '',
    ruleprofile4: '',
    ruletext1:
      "1 、 Al fine di predicare il concetto di risorse digitali ed espandere la scala degli utenti, NTLEX.COM ha lanciato il programma' Promotion Partner ', che è efficace da molto tempo.",
    ruletext2:
      "2 、 Invitare gli amici può essere diviso in due livelli. Se A invita B, allora B è l'amico di primo livello di A. Se B invita C, allora C appartiene all'amico di primo livello di B e anche all'amico di secondo livello di A. ",
    ruletext3:
      '3 、 Quando si promuove la registrazione di amici, gli amici di primo livello degli invitanti possono essere solo gli amici di primo livello degli invitanti tramite collegamenti forniti dagli invitanti o inserendo manualmente i codici di invito degli invitanti.',
    ruletext4:
      '4 、 Chi viene invitato completa la registrazione attraverso un codice di invito, e l’incentivo per il lavoro a domicilio viene dato alla luce.',
    ruletext5:
      '5 、 Lo sconto è concesso per un periodo di un mese a decorrere dalla data in cui l’interessato ha terminato la sua iscrizione e in proporzioni diverse a seconda dei livelli.',
    ruletext6:
      "6 、 La promozione delle risorse su commissione è la commissione di transazione della valuta dell'amico di livello inferiore, che è le tre valute di base del mercato, ovvero USDT, BTC ed ETH.",
    ruletext7:
      '7 、 La proporzione e la durata della commissione di promozione sono positivamente correlate al numero di amici di primo livello. Maggiore è il numero della promozione, maggiore è la percentuale di commissione godibile. La promozione specifica del rapporto di sconto della commissione è la seguente ：',
    ruletext8:
      '8 、 TOP10 o TOP100 riceveranno incentivi aggiuntivi da MKWORLDS di volta in volta.',
    ruletext9:
      '9 、 Se altre attività sono in conflitto con le attività del Partner promotore, i Partner dovranno capire se cambiare temporaneamente dopo la consultazione.',
    ruletext10:
      '10 en L4 (Xunfu), L5 (Taishou) e L6 (Jiedushi) i partner a livello di inviato hanno diritto rispettivamente al 5%, 10% e 15% di bonus sui rendimenti annuali totali della Commissione.',
    ruletext11:
      "11 、 Il diritto dell'interpretazione finale di questa attività appartiene a NTLEX.COM.",
    ruleexampletitle: 'Per esempio:',
    ruleexamplecontent1:
      "Se l'utente Xiaoyan invitava 100 amici di prima classe, gli amici di prima classe di TA invitavano cinque amici di seconda classe, allora Xiaoyan aveva 100 amici di prima classe e 500 amici di seconda classe. Se la persona media scambia 3000 yuan al giorno, Il reddito mensile di Xiaoyan è di circa (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%) * 30 = 7200 / mese ",
    ruleexamplecontent2:
      "Se l'utente Xiaoyan invitava 1000 amici di prima classe, gli amici di prima classe TA invitavano 5 amici di seconda classe, Xiaoyan aveva 1000 amici di prima classe e 5000 amici di seconda classe. Se la persona media scambia 3000 yuan al giorno, il mensile di Xiaoyan il reddito è di circa (1000 * 3000 * 0,001 * 50% + 5000 * 3000 * 0,001 * 20%) * 30 = 135000 / mese ",
    lastupdate: 'Ultimo aggiornamento in',
    laststastic: 'Last stastic in',
    level: 'Livello',
    lv1: 'Lizheng',
    lv2: 'Xianling',
    lv3: 'Zhifu',
    lv4: 'Xunfu',
    lv5: 'Taishou',
    lv6: 'Jiedushi',
    levelonecount: 'Numero di livello uno',
    levelonecommission: 'Rapporto di ritorno di livello uno / tempo di ritorno',
    leveltwocommission: 'Rapporto di ritorno di livello due / tempo di ritorno',
    partnerdivide: 'Partner Dividend',
    day: 'cielo',
    alllife: 'Tutta la vita',
    totalcommissionrank: 'Promozione della Commissione totale',
    rank: 'No.',
    userid: 'ID utente',
    rankday: '(Giorno)',
    rankweek: '(Settimana)',
    rankmonth: '(Mese)',
    rankall: '(Tutti)',
    promotioncount: 'Numero di promozioni',
    commissionusdt: 'Commissione (USDT)',
    ranktip1:
      "Il numero di inviti è il numero di amici di prima classe. Questo elenco classifica l'importo totale delle commissioni da grande a piccolo.",
    ranktip2:
      "Il numero di inviti è il numero di amici di prima classe. L'elenco è classificato in base al numero di amici di prima classe invitati.",
    thanks: 'Grazie per aver supportato NTLEX.COM！',
    headertip:
      'I dati di cui sopra non vengono aggiornati in tempo reale. Le statistiche di sistema e si aggiornano ogni 24 ore.',
    ptools: 'Strumenti di promozione',
    pt_title: 'Buono regalo di criptovaluta',
    pt_desc: 'Questa è una sorpresa dal futuro, inviare amici, parenti, clienti, partner.',
    pt_more: 'Altri strumenti in arrivo',
    pt_tips:
      "Se hai una buona idea, invia un'email a promotion@NTLEX.COM, con una ricompensa dopo l'adozione.！",
    pt_card_amount: 'Importo della carta',
    pt_card_deadline: 'Scadenza',
    pt_card_noend: 'Indefinito',
    pt_card_btn: 'Ottieni 30 carte gratis',
    pt_card_btn1: 'I partner di promozione ottengono gratis',
    pt_card_btn2: '',
    pt_card_btn_login: 'Per favore fai prima il log in',
    pt_card_rule: 'Dettagli regola',
    pt_card_summary:
      'La carta regalo in valuta digitale è uno strumento promozionale sviluppato per consentire ai partner promozionali di invitare meglio gli amici offline. Quando gli utenti si scambiano le carte regalo, diventeranno automaticamente amici offline dei partner promozionali.',
    pt_card_rule1:
      "1. Le carte regalo gratuite sono limitate a 30 carte per utente. Se è necessario emettere più carte regalo, gli utenti devono pagare per la personalizzazione, che può personalizzare la quantità di carte, LOGO, istruzioni, ecc. Per requisiti personalizzati, si prega di invia un'e-mail a ",
    pt_card_rule2:
      '2. I buoni regalo gratuiti sono limitati a una copia per utente. I buoni regalo gratuiti emessi dal governo NTL sono limitati a uno per ogni utente. Anche se diversi utenti ricevono buoni regalo gratuiti con codici di scambio diversi, solo uno può essere scambiato. Le carte regalo personalizzate non sono soggette a questa restrizione. ',
    pt_card_rule3:
      "3. Prima che l'utente cambi la carta regalo, se non è presente alcun 'inviter' (ovvero il codice di invito non è stato inserito al momento della registrazione dell'account), verrà automaticamente associato all'amico di primo livello del l'emittente della carta. Se A non inserisce un codice di invito durante la registrazione di un account, A non appartiene a nessuno dei propri amici di primo o secondo livello, ma quando A viene convertito negli amici di primo livello di B tramite la carta regalo emessa da B, A diventa automaticamente gli amici di primo livello di B. ",
    pt_card_rule4:
      "4. Per evitare lo spazzolamento, il valore contabile delle carte regalo non viene pagato in tempo reale. Verrà congelato per 180 giorni dopo la raccolta e rilasciato automaticamente nel saldo dell'account utente dopo 180 giorni.",
    pt_card_rule5:
      '5. Quando si ricevono buoni regalo gratuiti, dobbiamo completare la certificazione con il nome reale. Durante la conversione, possiamo ottenerli senza completare la certificazione con il nome reale. Questo per facilitare i promotori ad ottenere più rapidamente amici di livello inferiore.',
    pt_card_rule6:
      '6. Il diritto di interpretazione finale delle carte regalo gratuite appartiene a ntlex.com.',
    pt_card_day: 'Giorni',
    pt_card_title_tips: 'Contributo promozionale gratuito di 2000 CNY',
    pt_card_title_tips1: 'collare',
    pt_card_title_tips2: 'Contributo promozionale',
    pt_card_receivew_success:
      'Congratulazioni! Raccolta riuscita di carte regalo per promozioni partner! Vai al Centro personale -> Centro carte e voucher.',
    usepromotion: 'Utilizza materiali promozionali',
    saveimage: 'Salva immagine',
    imagetips:
      'Se non riesci a scaricare le immagini correttamente, scaricale utilizzando lo strumento screenshot!',
    pt_invite_title: "Opuscolo di registrazione dell'invito",
    pt_invite_desc:
      "Diventa automaticamente amici subordinati tramite la registrazione del codice bidimensionale, adatto per l'inoltro in vari gruppi o forum.",
    colum_text0: 'Rango',
    colum_text1: 'Membro',
    colum_text2: 'Promozione',
    colum_text3: 'Commissione (USDT)',
    colum_text4: 'Ricompensa extra',
    context_title: 'Codice di riscatto esclusivo per partner promozionali',
    context_title1: 'Scansiona per saperne di più',
    context_title2: 'Il mio codice di invito',
    context_title3: 'Immagine invito',
  },
  uc: {
    retrieveprivate: {
      findText: "Recupera la chiave privata dell'account",
      findText2: 'La chiave privata del numero è stata ricostituita',

      inputFindtext: "Inserisci l'email legata a questo account",
      continue: 'continua',
    },
    verify: 'Finisci prima KYC',
    login: {
      welcomelogintxt: "Benvenuti all'NTL!",
      welcomelogintxt2: 'Se non hai un account',
      welcomelogintxt3: 'Potete cliccare qui',
      welcomelogintxt4: 'Conto registrato',
      welcomelogintxt6: 'Se hai un account',
      welcomelogintxt7: 'Un viaggio verso un accordo completamente nuovo',
      phoneEmail: 'Accesso al telefono cellulare o e-mail',
      inputPrivate: "Inserisci la chiave privata dell'account...",
      welcomelogintxt5: 'Account di accesso',
      forgetPrivateTxt: 'Hai dimenticato la chiave privata del conto?',
      anonymousLogin: 'Accesso anonimo',
      noaccount: 'Nessun account？',
      register: 'Iscriviti',
      login: 'Accesso',
      welcomelogin: 'Benvenuto',
      usertip: 'Inserisci numero di telefono o email',
      pwdtip: 'Inserire la password',
      validatecodeload: 'Caricamento codice di verifica',
      validatemsg: 'Completa prima la verifica',
      forget: 'Dimenticare la password?',
      loginvalidate: 'Inserisci indirizzo email o numero di telefono',
      pwdvalidate1: 'Inserisci la password',
      pwdvalidate2: 'Lunghezza della password non inferiore a sei',
      success: 'Successo',
      goregister: 'Verso la registrazione',
      getlostpwd: 'Dimenticare la password',
    },
    forget: {
      title: 'Trova password',
      hasaccount: 'Avere un account？ per accedere',
      login: 'Accesso',
      sendcode: 'Spedire',
      newpwd: 'Inserire una nuova password',
      confirmpwd: 'Inserisci di nuovo la nuova password',
      save: 'Invia',
      pwdvalidate1: 'Inserisci conferma password',
      pwdvalidate2: 'Password non uguale!',
      resettelpwd: 'Reimposta password tel',
      resetemailpwd: 'Reimposta password email',
      newpwdtip: 'Inserire una nuova password',
      pwdvalidate3: 'Lunghezza della password non inferiore a sei',
      telno: 'Numero di telefono',
      smscode: 'Codice di verifica SMS',
      teltip: 'Inserisci tel',
      smscodetip: 'Inserisci codice di verifica sms',
      email: 'E-mail',
      password: 'password',
      NoId: 'Il numero di conto non è ancora disponibile',
      emailcode: 'Codice di verifica email',
      emailtip: "Inserisci l'email",
      emailcodetip: 'Inserisci codice di verifica email',
      resetpwdsuccess: 'Reimpostazione password riuscita',
      smswarn: 'Verifica la presenza di SMS',
      bangding: 'Legatura del codice di scansione',
      googleAuth: 'Validatore Google',
      pleaseGoogleAuth: 'Collega il validatore Google',
      bindGoogleAuth: 'Legato al validatore Google',
      jcbind: 'Sblocca',
    },
    finance: {
      center: 'Centro finanziario',
      personalassets: 'Asset valutari',
      swapassets: 'Swap Assets',
      billdetail: 'Dettaglio fattura',
      charge: 'Deposito',
      pickup: 'Ritiro',
      tradetail: 'Commercio minerario',
      paydividends: 'Paga dividendi',
      invitingmining: 'Inviting mining Awards',
      money: {
        cointype: 'Moneta',
        balance: 'Equilibrio',
        frozen: 'Frozen Balance',
        operate: 'Azione',
        charge: 'Deposito',
        pickup: 'Ritiro',
        onkeytrans: 'Trans',
        getaddress: 'Ottieni indirizzo',
        resetsuccess: 'Reimposta operazione riuscita',
        match: 'Incontro',
        matchtip1: 'Importo GCX corrispondenza disponibile',
        matchtip2: 'Inserisci importo partita',
        matcherr1: 'Inserisci una quantità valida!',
        matcherr2: 'Supera il numero massimo di corrispondenze!',
        matchsuccess: 'Partita riuscita!',
        needreleased: 'Risorse da rilasciare',
        totalassets: 'Valore totale stimato delle attività ：',
      },
      swap: {
        totalassets: 'Valore totale stimato delle attività ：',
        swap: 'Swap',
        swaptype: 'SWAP',
        swapassets: 'Conto capitale',
        avabalance: 'Margine Avali',
        usebalance: 'Margine utilizzato',
        frozenbalance: 'Margine congelato',
        profitandloss: 'Pl non realizzato',
        transfor: 'Trasferimento',
        inputtransferamount: 'Importo del trasferimento',
        all: 'Tutti',
        currencyaccount: 'Account Spot',
        swapaccount: 'Conto di scambio perpetuo',
        clickchange: 'Fare clic per cambiare direzione',
        avaamount: 'Disponibile',
        pleaseselectwallet: 'Scegli un pugno di portafoglio di trasferimento.',
        pleaseinputamount: "Inserisci l'importo del trasferimento",
        oktransfer: 'Trasferisci ora',
      },
      trade: {
        accumulative_return: 'Le tasse minerarie sono state rimborsate (BHB):',
        accumulat_return: 'Le tasse minerarie dovrebbero essere rimborsate (BHB):',
        start_end: 'Inizio-Fine',
        account_date: 'Tempo per ricevere la capitale',
        to: 'Per',
        operatetype: 'Tipo di azione',
        search: 'Ricerca',
        charge: 'Caricare',
        pickup: 'Raccogliere',
        transaccount: 'Trasferimento',
        exchange: 'Exchange',
        otcbuy: 'OTC-Buy',
        otcsell: 'OTC-Sell',
        activityaward: "Premio per l'attività",
        promotionaward: 'Premio promozione',
        dividend: 'Dividendo',
        vote: 'Votazione',
        handrecharge: 'Ricarica artificiale',
        match: 'Incontro',
        activitybuy: 'Acquisto attività',
        ctcbuy: 'CTC-Buy',
        ctcsell: 'CTC-Sell',
        chargetime: "tempo di generazione dell'ordine",
        type: 'Genere',
        num: 'Quantità',
        status: 'Stato',
        finish: 'Finito',
        fee: 'Restituzione delle tasse minerarie',
        transactionTime: 'Tempo di trading',
        symbol: 'Coin Pair',
        direction: 'Direzione',
        price: 'Prezzo',
        entrustment: 'Affidamento',
        havedeal: 'Ho fatto un affare',
        poundageAmount: 'Costo del servizio ',
        exchangeOrderId: "L'ID ordine",
        mineAmount: 'Dig a currency (BHB)',
        buy: 'ACQUISTA',
        sell: 'VENDERE',
        limit: 'LIMIT',
        market: 'MERCATO',
        clear: 'Condizione chiara',
        turnover: 'Turnover',
      },
      inviting: {
        accumulative_return: "L'invito a premi minerari è stato restituito e accumulato (BHB):",
        accumulat_return: 'Invita la restituzione dei premi minerari (BHB):',
        account_date: 'Tempo per ricevere la capitale',
        start_end: 'Inizio-Fine',
        to: 'Per',
        operatetype: 'Tipo di azione',
        search: 'Ricerca',
        charge: 'Caricare',
        pickup: 'Raccogliere',
        transaccount: 'Trasferimento',
        exchange: 'Exchange',
        otcbuy: 'OTC-Buy',
        otcsell: 'OTC-Sell',
        activityaward: "Premio per l'attività",
        promotionaward: 'Premio promozione',
        dividend: 'Dividendo',
        vote: 'Votazione',
        handrecharge: 'Ricarica artificiale',
        match: 'Incontro',
        chargetime: "tempo di generazione dell'ordine",
        type: 'Genere',
        num: 'Quantità',
        status: 'Stato',
        finish: 'Finito',
        fee: 'Commissione',
        symbol: 'Simbolo moneta',
        refereename: "Nome dell'arbitro",
        referetel: "Numero di cellulare dell'arbitro",
        invitingawards: 'Inviting mining Awards (BHB)',
        refere: 'Arbitro',
        refereinput: 'Inserisci il nome / numero di cellulare',
      },
      paydividende: {
        money_holding: 'La condivisione del denaro è stata restituita e accumulata (ETH):',
        money_hold: 'Paga dividendi per restituire (ETH):',
        paydividends: 'Paga dividendi (ETH)',
        account_date: 'Tempo per ricevere la capitale',
        datehodld: 'Data di detenzione di denaro',
        start_end: 'Inizio-Fine',
        to: 'Per',
        operatetype: 'Tipo di azione',
        search: 'Ricerca',
        charge: 'Caricare',
        pickup: 'Raccogliere',
        transaccount: 'Trasferimento',
        exchange: 'Exchange',
        otcbuy: 'OTC-Buy',
        otcsell: 'OTC-Sell',
        activityaward: "Premio per l'attività",
        promotionaward: 'Premio promozione',
        dividend: 'Dividendo',
        vote: 'Votazione',
        handrecharge: 'Ricarica artificiale',
        match: 'Incontro',
        chargetime: 'Tempo di ricarica',
        type: 'Genere',
        num: 'Quantità',
        status: 'Stato',
        finish: 'Finito',
        fee: 'Commissione',
        symbol: 'Simbolo moneta',
      },
      second: {
        secondaccount: 'Conto secondo contratto',
        swap: ' Conto secondo contratto',
      },
      finance: {
        transfer: 'trasferimento finanziario',
        account: 'conto finanziario',
        balance: 'equilibrio',
        earn: 'interessi maturati',
        rate: "tasso d'interesse",
        confirm: 'Conferma il trasferimento',
        transferAmount: 'Importo del trasferimento',
        all: 'trasferisci tutto',
        coin: 'valuta',
        open: 'Record di posizione',
        close: 'Record di posizione chiusa',
        fail: 'operazione fallita',
        success: 'Operazione riuscita',
        updateTime: 'tempo di aggiornamento',
        financialManagement: 'Gestione finanziaria',
        financialOrder: 'Ordine finanziario',
      },
      record: {
        start_end: 'Inizio-Fine',
        to: 'Per',
        code: 'codifica',
        remark: 'Il commento',
        operatetype: 'Tipo di azione',
        search: 'Ricerca',
        charge: 'Caricare',
        pickup: 'Raccogliere',
        transaccount: 'Trasferimento',
        exchange: 'Exchange',
        otcbuy: 'OTC-Buy',
        otcsell: 'OTC-Sell',
        activityaward: "Premio per l'attività",
        promotionaward: 'Premio promozione',
        dividend: 'Dividendo',
        vote: 'Votazione',
        handrecharge: 'Ricarica artificiale',
        match: 'Incontro',
        chargetime: 'Tempo di ricarica',
        type: 'Genere',
        num: 'Quantità',
        status: 'Stato',
        finish: 'Finito',
        fee: 'Commissione',
        shouldfee: 'Commissione da pagare',
        discountfee: 'Addebito detrazione',
        realfee: 'Costo del servizio',
        symbol: 'Simbolo moneta',
        activitybuy: 'Acquisto attività',
        ctcbuy: 'C2C ACQUISTA',
        ctcsell: 'C2C SELL',
        redout: 'RED-OUT',
        redin: 'RED-IN',
        quickExchange: 'Scambio rapido',
        currentRate: 'Tasso di cambio corrente',
        from: 'A partire dal',
        inputexchangeamount: 'Input Quick Exchange Amount',
        inputexchangepasswd: 'Input Exchange Password',
        chooseTransCoinUnit: 'Scegli Trans Coin',
        inputTransAmount: "Scegli l'importo della transazione",
        predictAmount: 'Will Exchange',
        qamount: 'Amout',
        qrate: 'Vota',
        qexamount: 'Exchange Amount',
        withdrawcodein: 'WithdrawCode Recharge',
        withdrawcodeout: 'WithdrawCode Withdraw',
        contractfee: 'Commissione di swap',
        contractprofit: 'Swap Profit',
        contractloss: 'Swap Loss',
        optionfail: 'Opzione non riuscita',
        optionfee: 'Commissione di opzione',
        optionreward: 'Premio opzione',
        other: 'Altro',
      },
      recharge: {
        recharge: 'Deposito',
        symbol: 'Moneta',
        address: 'Indirizzo di deposito',
        copy: 'Copia',
        qrcode: 'QR Code',
        qrcodeaddress: 'QRCode per deposito',
        msg1: "Non ricaricare le attività non valutarie all'indirizzo sopra indicato, altrimenti le attività non verranno recuperate.",
        msg2: "Dopo aver ricaricato all'indirizzo sopra, è necessario confermare l'intero nodo di rete, dopo che sono arrivate 2 conferme di rete, dopo che è possibile estrarre 6 conferme di rete.",
        msg3: 'Importo minimo di ricarica:',
        msg3_1: ", la ricarica inferiore all'importo minimo non verrà conteggiata.",
        msg4: 'Il tuo indirizzo di ricarica non cambierà frequentemente e puoi ripetere la ricarica; se ci sono cambiamenti, proveremo a notificarti tramite annuncio sul sito web o email.',
        msg5: 'Assicurati di confermare la sicurezza del tuo computer e browser per evitare che le informazioni vengano manomesse o diffuse.',
        record: 'Registrazione',
        copysuccess: 'Success！',
        copyerr: 'Errore！ Copialo manualmente',
        time: 'Orario di arrivo',
        amount: 'Quantità',
        gettingaddress: 'Recupero indirizzo di deposito ， Attendi ...',
        getaddress: 'Ottieni indirizzo di deposito',
        memotips: 'Inserisci questo promemoria durante la ricarica, altrimenti perderai risorse.',
        withdrawrecharge: 'Ricarica tramite codice',
        coderechargetip: 'Inserisci il codice di prelievo',
        rechargesuccess: 'Congratulazioni, Ricarica riuscita!',
        rechargeconfirm: 'Conferma ricarica',
        status: 'Stato',
        protocol: 'Protocollo di rete',
        status_0: 'fallire',
        status_1: 'non ricevuto',
        status_2: 'accreditato',
        protocolerr: 'Seleziona un accordo',
        network: 'Internet',
        notaddress:
          "Non hai richiesto un indirizzo di deposito，Fare clic sul pulsante per ottenere l'indirizzo di deposito",
        rechargeDisable: 'La funzione di ricarica è temporaneamente non disponibile',
      },
      withdraw: {
        pickup: 'Raccogliere',
        network: 'rete di trasferimento',
        withdrawDisable: 'Sospendere i prelievi',
        addressmanager: 'Gestione indirizzi',
        withdrawbycode: 'Preleva con codice',
        withdrawcode: 'Preleva codice',
        symbol: 'Moneta',
        address: 'Indirizzo',
        num: 'Quantità',
        avabalance: 'Saldo disponibile',
        msg1: 'La quantità di monete è inferiore a',
        msg2: "Arriva automaticamente all'account, altrimenti è necessaria la revisione manuale",
        increase: 'Aumenta il credito',
        tip1: 'Inserisci fino a',
        tip11: 'posizioni decimali e il valore minimo è',
        tip2: 'Il valore massimo è',
        numtip1: 'Inserisci il numero di monete',
        fee: 'Commissioni',
        range: 'Gamma',
        arriamount: 'Il numero di arrivi',
        msg3: 'Il numero minimo di monete è',
        msg4: 'moneta',
        msg5: "Al fine di garantire la sicurezza dei fondi, quando la politica di sicurezza del tuo account cambia, le password vengono cambiate e utilizzi il nuovo indirizzo per prelevare le monete, effettueremo un controllo manuale delle monete. Sii paziente e attendi lo staff per chiamare o inviare un'e-mail. ",
        msg6: 'Assicurati di confermare la sicurezza del tuo computer e browser per evitare che le informazioni vengano manomesse o diffuse.',
        record: 'Registro prelievi',
        symboltip: 'Seleziona una valuta',
        addresstip: "Inserisci l'indirizzo",
        numtip2: 'Inserisci il numero corretto di monete, il valore minimo è',
        numtip3:
          "L'importo della monetazione non deve essere inferiore alla commissione di elaborazione",
        amounttip: "Inserisci l'importo",
        feetip1: 'La tariffa minima è',
        feetip2: 'Il valore massimo è',
        time: 'Tempo di ritiro',
        status: 'Stato',
        status_1: 'in lavorazione',
        status_2: 'Trasferimento',
        status_3: 'Fallimento',
        status_4: 'Successo',
        remark: 'Nota',
        add: 'Inserisci',
        addresslist: 'Elenco indirizzi',
        safevalidate: 'Verifica di sicurezza',
        telno: 'Tel',
        smscode: 'Codice di verifica del telefono',
        second: 'secondo',
        clickget: 'Ottenere',
        email: 'E-mail',
        emailcode: 'Codice di verifica email',
        save: 'Salva',
        delete: 'Elimina',
        telerr: 'Numero di telefono errato',
        emailerr: 'Email errata',
        codeerr: 'Codice di verifica errato',
        remarktip: 'Inserisci commento',
        savemsg1: 'Impossibile salvare!',
        savemsg2: 'Salvato con successo!',
        operate: 'Aziona',
        fundpwdtip: 'Inserisci la password dei fondi',
        click: 'clic',
        filtrate: 'può filtrare',
        txid: 'TxId',
        generateCode: 'Genera WithdrawCode',
        withdrawcodelist: 'WithdrawCode List',
        withdrawcodestatus: 'Stato',
        submit: 'Invia',
        generatecodesuccess: 'WithdrawCode generato!',
        code_status0: 'Inutilizzato',
        code_status3: 'successo',
        network: 'rete di trasferimento',
        protocol: 'Protocollo di rete',
      },
    },
    member: {
      usercenter: 'Profilo utente',
      securitycenter: 'Centro di sicurezza',
      securitysetting: 'Impostazioni di sicurezza',
      accountsetting: 'Impostazione conto',
      account: 'Account',
      assets: 'Finanza',
      exchange: 'Exchange',
      curdelegate: 'Delegato attuale',
      hisdelegate: 'Delegato della storia',
      otc: 'OTC',
    },
    order: {
      ordercenter: 'Centro ordini',
      myorder: 'Il mio ordine',
      myad: 'Il mio annuncio',
    },
    regist: {
      anonymousLogin: 'Accesso anonimo',
      SaveKey: 'Per favore, salvate le chiavi',
      zhanghaosiyao: "Chiave privata dell'account",
      logintishi:
        'La chiave privata al momento del log on url url è il numero del conto; le chiavi private sono create localmente in modo casuale e tenute in debita considerazione con un clic che può essere copiato automaticamente',
      nimingtishiTxt:
        'La chiave privata del conto consente di collegarsi al numero di conto, che viene creata a caso a livello locale e che deve essere tenuta in debita considerazione; se si perde la casella postale che può essere legata al numero di conto, non si può recuperarla!',

      shuruningcheng: 'Inserisci nickname',
      fillInvitationCode: "Compila il codice dell'invito",

      go_login: 'Numero di conto disponibile',
      go_login2: 'Andare a fare il log on',
      hasaccount: 'Avere un account？ per accedere',
      login: 'Accesso',
      username: 'Nome utente',
      country: 'Nazione',
      smscode: 'Codice di verifica SMS',
      sendcode: 'Spedire',
      resendcode: 'Invia di nuovo (',
      pwd: "Parola d'ordine",
      repwd: 'Conferma password',
      confrimpwd: 'Conferma password',
      agreement: 'accettare',
      userprotocol: 'Accordo per gli utenti',
      privacypolicy: 'Politica in materia di tutela della vita privata',

      regist: 'Iscriviti',
      teltip: 'Inserisci tel',
      telerr: 'Errore nel formato del telefono, inserisci di nuovo',
      emailtip: "Inserisci l'email",
      emailerr: "Errore nel formato dell'email, inserisci di nuovo",
      confirmpwdtip: 'Inserisci conferma password',
      confirmpwderr: 'Due password non uguali!',
      telregist: 'Tel Regist',
      emailregist: 'Email Regist',
      usernametip: 'Inserire username',
      usernamemsg: 'Lunghezza del nome utente non inferiore a 3, non superiore a 15',
      countrytip: 'Seleziona il paese',
      smscodetip: 'Inserisci codice di verifica sms',
      pwdtip: 'Immettere la password di accesso',
      pwdmsg: 'Lunghezza della password non inferiore a 6',
      telno: 'Tel',
      email: 'E-mail',
      agreementtip: 'Fai clic per accettare',
      reloadChoice: 'Si prega di ri-registrarsi',
      modaltitle: 'Si prega di verificare',
      promotion: 'Codice di invito facoltativo',
      china: 'Cina',
      singapore: 'Singapore',
      korea: 'Corea',
      japan: 'Giappone',
      thailand: 'Tailandia',
      russia: 'Russia',
      uk: 'Regno Unito',
      vietnam: 'Vietnam',
      india: 'indio',
      italy: 'Italia',
      hk: 'Hong Kong',
      malaysia: 'Malaysia',
      taiwan: 'taiwan',
      turkey: 'tacchino',
      germany: 'Germania',
      france: 'Francia',
      spain: 'Spagna',
      us: 'stati Uniti',
      canada: 'Canada',
    },
    safe: {
      oldprivateKey: 'Chiave privata',
      privateKeytip: 'Inserisci la chiave privata',
      safelevel_low: 'Livello di sicurezza: basso',
      safelevel_high: 'Livello di sicurezza: alto',
      safelevel_medium: 'Livello di sicurezza: medio',
      nickname: 'Nickname',
      bind: 'Bind',
      binded: 'Vincolato',
      verifypass: 'Verificato',
      binding: 'Associa',
      binderr: 'Fallimento',
      bindretry: 'Riprova',
      verified: 'Verificato',
      notverified: 'Non verificato',
      verifiedtip:
        'Per proteggere la sicurezza del tuo account, completa la certificazione del nome reale prima di poter effettuare operazioni commerciali!',
      realname: 'Nome effettivo',
      idcard: "Carta d'identità",
      upload: 'Carica',
      upload_positive: 'Carica foto ID anteriore',
      upload_negative: "Carica la foto inversa della carta d'identità",
      upload_hand: 'Carica foto tessera palmare',
      save: 'Salva',
      reset: 'Ripristina',
      email: 'E-mail',
      bindemail: 'Associa email',
      loginpwd: 'Password per il login',
      emailcode: 'Codice di verifica email',
      clickget: 'Fai clic per ottenere',
      second: 'S',
      phone: 'Telefono',
      bindphone: 'Bind telphone',
      phonecode: 'Codice di verifica del telefono',
      logintip: 'Da utilizzare quando si accede alla piattaforma',
      edit: 'Modificare',
      oldpwd: 'Vecchia password di accesso',
      newpwd: 'Nuova password di accesso',
      confirmnewpwd: 'Conferma la nuova password',
      fundpwd: 'Password fondo',
      fundtip: "Quando i fondi dell'account cambiano, devi prima verificare la password dei fondi",
      set: 'Impostato',
      confirmpwd: 'conferma password',
      oldfundpwd: 'Vecchia password fondo',
      newfundpwd: 'Password nuovo fondo',
      newpwdmsg1: 'Immettere non meno di 6 nuove password di accesso',
      newpwdmsg2: 'La nuova password di accesso non è coerente',
      pwdmsg1: 'Immettere non meno di 6 password',
      pwdmsg2: 'Password incoerente',
      emailtip: 'Inserisci e-mail',
      codetip: 'Inserisci il codice di verifica',
      telnotip: 'Inserisci il numero di telefono',
      oldpwdtip: 'Inserisci la password originale',
      realnametip: 'Inserisci il tuo vero nome',
      idcardtip: 'Immettere il numero ID',
      bindphonetip: 'Per favore, collega prima il tuo telefono!',
      resetfundpwd: 'Reimposta password fondi',
      upload_positivetip: "Carica la parte anteriore del documento d'identità con foto",
      upload_negativetip: "Carica il retro del documento d'identità con foto",
      upload_handtip: 'Carica foto tessera palmare',
      save_success: 'Successo!',
      save_failure: 'Fallimento!',
      imgtip: 'Carica il tuo codice QR per ricevere contanti',
      idcard_verifymsg1:
        '1. Il file è inferiore a 8 M. Le informazioni sul documento devono essere chiaramente visibili, non sono consentite modifiche nel documento o nella copertina da parte di oggetti estranei e il numero e il nome del documento devono essere visibili.',
      idcard_verifymsg2:
        '2. La fotografia dovrebbe mostrarti senza cappello. Si consiglia di non truccarsi. I tratti del viso dei portadocumenti a mano devono essere chiari e le braccia devono essere completamente esposte.',
      idcard_verifymsg3:
        "3. Necessità di tenere sia documenti in mano che copia manoscritta (nome + data della domanda),' Tutte le mie azioni su questo sito sono operazioni mie e comprendo i rischi coinvolti e sono disposto a sopportare tutte le conseguenze legali di ciò account.'",
    },
    account: {
      successDelete: 'Cancellazione riuscita',
      pagetitle: 'Associa account con nome reale',
      pagetip:
        'Imposta il metodo di pagamento, assicurati di utilizzare il mio account con il nome reale',
      backcardno: 'Conto bancario',
      backcardtip: 'I dati della carta di credito personale non sono vincolati',
      modify: 'Modificare',
      bind: 'Bind',
      name: 'Nome',
      bankaccount: 'Conto bancario',
      bankbranch: 'Filiale bancaria',
      bankno: 'Numero banca',
      confirmbankno: 'Conferma numero carta',
      fundpwd: 'Password fondo',
      save: 'Salva',
      zfbaccount: 'Account Alipay',
      zfbaccounttip: "L'account Alipay personale non è vincolato",
      wxaccount: 'Account Wechat',
      wxaccounttip: "L'account Wechat personale non è vincolato",
      banknomsg1: 'Inserisci il numero di carta di credito corretto',
      banknomsg2: 'Il numero di carta di credito inserito due volte non è coerente!',
      verifiedmsg: "Eseguire prima l'autenticazione del nome reale",
      bankaccountmsg: 'Seleziona la tua banca',
      bankbranchmsg: "Immetti filiale dell'account",
      banknomsg: 'Inserisci il numero di carta di credito corretto',
      fundpwdmsg1: 'Inserisci la password del fondo corretta',
      fundpwdmsg2: 'La password non può contenere meno di 6 caratteri',
      zfbaccountmsg: "Inserisci l'account Alipay",
      wxaccountmsg: "Inserisci l'account WeChat",
      save_success: 'Successo!',
      save_failure: 'Fallimento!',
    },
    otcorder: {
      unpaid: 'Non pagato',
      paided: 'Pagato',
      finished: 'Finito',
      canceled: 'Annullato',
      appealing: 'Attraente',
      searchtip: "Inserisci il numero dell'ordine",
      orderno: "Numero d'ordine",
      created: 'Tempo',
      symbol: 'Moneta',
      type: 'Genere',
      type_sell: 'vendere',
      type_buy: 'acquista',
      tradename: 'Nome depositato',
      amount: 'Quantità',
      money: 'I soldi',
      fee: 'Commissione',
    },
    identity: {
      certified: 'già certificato',
      placeholder: 'Inserisci il motivo della cancellazione',
      apply: 'Fai domanda per diventare impresa',
      become: 'Diventa azienda certificata NTL e goditi maggiori privilegi di transazione',
      zhusnhu:
        'Le aziende godono di cabine pubblicitarie esclusive per aumentare il successo delle transazioni',
      tijiaoziliao: 'Invia le informazioni di autenticazione del commerciante',
      place:
        'Carica le informazioni di autenticazione del commerciante preparate sulla piattaforma e inviale',
      tijiao: 'Il tuo controllo di certificazione commerciante è stato inviato',
      tijiaosuc: 'congratulazioni, la tua certificazione commerciante è stata superata',
      tijiaofail: 'Mi dispiace! La certificazione del tuo commerciante non è stata superata',
      zhuxiaotijiao: 'La tua domanda di annullamento aziendale è stata inviata',
      shenhefail: "La tua richiesta di annullamento dell'attività non è stata approvata",
      shenhesuc: 'La tua richiesta di annullamento aziendale è stata approvata',
      shangjiazhuxiao: "annullamento dell'attività",
      shenagain: 'revisione',
      shenheshibai: 'Audit Failed',
      sheqinggain: 'Per richiedere',
      reason: 'Motivo',
      shenqingtuibao: 'Richiedi prestito',
      getquan: 'Disponi delle seguenti autorizzazioni',
      read: 'Ho letto e accetto',
      lijishenqing: 'Applica immediatamente',
      tips: 'richiesta',
      wufachexiao:
        "Sei nell'operazione di annullamento dell'attività, dopo aver confermato l'invio dell'operazione di richiesta, non sarà possibile revocarla.",
      suredo: 'Sei sicuro che sia stato fatto?',
      shuzizichan: 'Certificato di compravendita di asset digitali',
      gerenzichan: 'Certificato di risorsa digitale personale',
      second: {
        line: 'Come fare domanda per affari?',
        step1: 'Passaggio 1: prepara i materiali per le candidature aziendali come richiesto',
        step1c1: 'Prepara la seguente applicazione:',
        step1c2:
          'Numero di cellulare, ID WeChat, numero QQ, certificato di risorsa digitale personale (immagine), certificato di transazione di risorsa digitale (immagine)',
        step2: 'Passaggio 2: invia la domanda',
        step2c:
          "Per completare i materiali per l'audit della certificazione aziendale che devono essere compilati e caricati, fare clic su Invia per approvazione.",
        step3: 'Passaggio 3: controllo dei dati',
        stepc:
          "Esamineremo le tue domande di lavoro per i prossimi tre-cinque giorni, tieni gli occhi aperti, ma puoi inviare una pagina. Dopo l'approvazione, puoi pubblicare l'annuncio nell'area di cambio valuta francese.",
        agree: 'Accettato di congelare',
        agreec: 'Come deposito commerciante',
        shenqingchngweishangjia: 'Candidati per affari',
      },
      yuanyin: 'Motivo',
      bizhong: 'Valuta di deposito',
      shuliang: 'Importo del margine',
      chosen: 'Seleziona la valuta',
      seat: 'Stand esclusivo',
      service: 'Servizio one-to-one',
      lowfee: 'Commissioni inferiori',
      phone: 'Telefono',
      balance: 'Beni personali',
      cardphoto: "Foto d'identità positive e negative",
      wx: 'Wechat',
      exchange: 'Se impegnarsi in scambi fuori borsa di risorse digitali',
      handphoto: 'Utente con foto di identificazione',
      qq: 'QQ',
      ploy: 'Se esiste una corrispondente strategia di controllo del rischio',
      agreement: '《Contratto commerciale certificato》',
      he: 'e',
      applyfor: 'Applicare',
      sendcode: 'Spedire',
      confirm: 'Confermare',
      prepare: 'Preparare i materiali',
      result: 'Attendi il risultato',
      review: 'Invia recensione',
      passed: 'Revisione superata',
      approve: 'Accetta il contratto per il commerciante di certificazione',
      emailtip1: 'Invia per email il seguente materiale a',
      emailtip2: 'Esamineremo la tua domanda il prima possibile.',
    },
    extension: {
      title1: 'Link di promozione',
      title2: 'Promozione amici',
      title3: 'La mia commissione',
      linkdesc:
        "Il seguente URL è il tuo indirizzo per la promozione al mondo esterno. Puoi promuoverlo tramite amici, QQ, Wechat, Weibo, blog, forum o il tuo sito web. Tutte le persone che hanno effettuato l'accesso tramite questo indirizzo saranno i tuoi utenti dopo la registrazione ., E quando questi utenti inviano strategie in questo sito, puoi guadagnare commissioni e la promozione dettagliata può essere visualizzata nel record di accesso. ",
      linktitle: 'I tuoi link romantici',
      copy: 'Copia',
      copy_msg1: 'Copia riuscita！',
      copy_msg2: 'Errore！ Copialo manualmente',
      username: 'Nome',
      currrecharge: 'Transazione',
      userlevel: 'Livello utente',
      createdtime: 'Ora di registrazione',
      currcommission: 'Commissione attuale',
      managerfee: 'commissione di gestione',
      yuan: 'yuan (RMB)',
      symbol: 'MONETA',
      amount: 'Quantità',
      remark: 'Nota',
      amounttime: 'Deliver Time',
    },
    promotion: {
      title: 'Centro promozioni',
      subtitle1: 'Le mie carte',
      subtitle2: 'Scambia record',
      subtitle3: 'La mia promozione',
      card_column0: 'Codice di scambio',
      card_column1: 'Nome',
      card_column2: 'Simbolo moneta',
      card_column3: 'Quantità',
      card_column4: 'Scadenza',
      card_column5: 'Totale',
      card_column6: 'Scambiato',
      card_column7: 'Crea ora',
      my_column0: 'Invita utente',
      my_column1: 'Data di registrazione',
      my_column2: 'Vero nome',
      gopromotion: 'Promozione',
      inputcardno: 'Inserisci il codice della carta',
      exchange: 'Exchange',
      exchangesuccess: "Congratulazioni！ Puoi controllare l'asset nel centro finanziario！",
      exchangewithcode: 'Scambia con codice',
    },
    activity: {
      navTitle: 'Innovazione',
      subNavTitle1: 'I miei ordini',
      subNavTitle2: 'Le mie miniere',
      subNavTitle3: 'My Locked',
      column1: 'Nome',
      column2: 'Genere',
      column3: 'Quantità',
      column4: 'Unità (IN)',
      column5: 'Unità (OUT)',
      column6: 'Stato',
      column7: 'Turnover',
      column8: 'Crea ora',
      mColumn1: 'Immagine',
      mColumn2: 'Nome',
      mColumn3: 'Coin Unit',
      mColumn4: 'Periodo',
      mColumn5: 'MiningDays',
      mColumn6: 'MiningedDays',
      mColumn7: 'Stato',
      mColumn8: 'Capacità di base',
      mColumn9: 'Capacità attuale',
      mColumn10: 'Total Mininged',
      mColumn11: 'Data di fine',
      mColumn12: 'Data creazione',
      lColumn1: 'Immagine',
      lColumn2: 'Nome',
      lColumn3: 'Coin Unit',
      lColumn4: 'Periodo',
      lColumn5: 'LockedDays',
      lColumn6: 'ReleaseDays',
      lColumn7: 'Stato',
      lColumn8: 'Capacità di base',
      lColumn9: 'Capacità attuale',
      lColumn10: 'Totale rilasciato',
      lColumn11: 'Data di fine',
      lColumn12: 'Data creazione',
    },
    mining: {
      title: 'Il mio elenco di mining',
      empty: 'Nessuna registrazione',
      day: 'Giorno',
      week: 'Settimana',
      month: 'Mese',
      year: 'Anno',
      invitetip1:
        'La capacità della macchina mineraria può essere migliorata invitando amici. Ogni persona invitata a scambiare la macchina mineraria aumenterà la capacità',
      invitetip2: "Limite superiore dell'aumento di capacità",
      miningUnit: 'Unità mineraria',
      miningPeriod: 'Periodo di estrazione',
      miningDays: 'Mining Times',
      miningedDays: 'Mininged Times',
      miningDaysProfit: 'Uscita di base',
      miningCurrentDaysProfit: 'Uscita corrente',
      status0: 'Da distribuire',
      status1: 'Distribuito',
      status2: 'Al di sopra di',
    },
    locked: {
      title: 'Il mio elenco bloccato',
      empty: 'Nessuna registrazione',
      day: 'Giorno',
      week: 'Settimana',
      month: 'Mese',
      year: 'Anno',
      invitetip1:
        'La capacità della serratura può essere migliorata invitando gli amici. Ogni persona invitata a scambiare la serratura aumenterà la capacità',
      invitetip2: "Limite superiore dell'aumento di capacità",
      miningUnit: 'Unità di rilascio',
      miningPeriod: 'Periodo di rilascio',
      miningDays: 'Release Times',
      miningedDays: 'Orari di rilascio',
      miningDaysProfit: 'Uscita di base',
      miningCurrentDaysProfit: 'Uscita corrente',
      status0: 'Per essere rilasciato',
      status1: 'Rilascio',
      status2: 'Al di sopra di',
      totallocked: 'Totale bloccato',
    },
    api: {
      apiAdmin: 'Gestione API',
      createApi: 'Crea una nuova chiave API',
      mark: 'commento',
      bindAddress: "La chiave dell'indirizzo IP non associata è valida per 90 giorni",
      hint: 'suggerimento',
      part1:
        'Ti forniamo una potente API, puoi utilizzare query di mercato, transazioni automatiche e altri servizi',
      apiDoc: 'dalla documentazione API.',
      howUse: 'Vedi come utilizzare',
      // part2: "Ogni utente crea fino a cinque set di chiavi API",
      part2: 'Crea fino a 5 set di chiavi API per utente',
      part3:
        "Non divulgare la tua chiave API per evitare la perdita di risorse. Per motivi di sicurezza, si consiglia di associare l'IP per la chiave API, con un massimo di 5 IP per ogni chiave API. Inserisci un unico indirizzo direttamente, più indirizzi IP per metà Virgole angolari, come 192.168.1.1, 192.168.1.2 invece, 192.168.1.3. ",
      myApiKey: 'La mia chiave API',
      ipAddress: 'Indirizzo IP',
      // createTime: "ora di creazione",
      createTime: 'CreateTime',
      accessKey: 'Chiave di accesso',
      bindIpAddress: 'Associa indirizzo IP',
      // ioDays: "Periodo di validità rimanente (giorni)",
      ioDays: 'I giorni rimanenti',
      operation: 'operazione',
      create: 'creare',
      edit: 'modificare',
      delete: 'Elimina',
      sureDelete: 'Sei sicuro di cancellare?',
      tips: 'La chiave viene visualizzata solo quando viene aggiunta, salvala in tempo.',
      copy: 'copia',
      access: 'chiave',
      okText: 'sicuro',
      cancel: 'Annulla',
    },
  },
  cms: {
    NewExclusive: 'I nuovi arrivati hanno diritto solo a questo tipo di formazione',
    Newtip:
      'Si è registrato l’account NTL, ha invitato amici e ha avuto l’opportunità di godere di uno sconto a vita',
    noticecenter: 'Centro annunci',
    newshelp: 'Aiuto nuovo utente',
    appdownload: 'Scarica app',
    onlineservice: 'Servizio Online',
    faq: 'FAQ',
    notice: 'Annuncio',
    servicecenter: 'Centro clienti',
    about: 'Di',
    joinus: 'Unisciti a noi',
    aboutus: 'Riguardo a noi',
    exchangerule: 'Regole di trading',
    useprotocol: 'Contratto di utilizzo',
    feenote: 'Descrizione addebito',
    merchantprocotol: 'Contratto commerciale',
    features: 'Caratteristiche',
    contactus: 'Contattaci',
    noticelist: 'Tutti gli annunci',
    nextnotice: 'IL PROSSIMO',
    prevnotice: 'PREV',
    notexist: 'La pagina che hai visitato non esiste o è stata eliminata',
    otherhelp: 'Altro in questa categoria',
    scanforshare: 'Scansiona per condivisione',
    download: 'Scarica',
    downloadslogan: 'NTL APP - Fai trading ovunque',
  },
  description: {
    title1: 'Sicurezza',
    title2: 'Servizio 24 ore su 24',
    title3: 'Global Exchange',
    title4: 'Strictly Project',
    message1:
      'Sistema di controllo del vento finanziario a tutto tondo e sistema antifurto, portafoglio caldo e freddo, sistema multi-firma per garantire la sicurezza dei fondi',
    message2:
      "L'audit manuale online 24 ore su 24 può proteggere i clienti dal perdere le migliori opportunità di investimento.",
    message3:
      'La copertura della rete di servizi aziendali globali ti aiuta a investire in risorse crittografate globali e a effettuare transazioni con utenti globali',
    message4:
      "Selezioniamo rigorosamente quei progetti blockchain di alta qualità per filtrare l'80% dei progetti ad altissimo rischio per te.",
    scanqrcode: 'Scansiona codice QR, scarica APP',
    aboutdesc1:
      'ntlex.com è una piattaforma di trading di asset digitali leader nel mondo, registrata nelle Isole Cayman, con un team operativo principale a Hong Kong. I membri principali di ntlex.com provengono dalle migliori società Internet e finanziarie. La maggior parte di loro crede profondamente in Bitcoin e nelle catene di blocchi. Siamo convinti che le catene di blocchi cambieranno il tradizionale sistema finanziario monopolistico e costruiranno una struttura sociale più democratica e autonoma. ',
    aboutdesc2:
      "La piattaforma ntlex.com ha un'architettura di trading di livello finanziario professionale, un motore di trading di corrispondenza della memoria simultanea ad alta capacità di sviluppo personale. La piattaforma utilizza un sistema di portafoglio ricaricabile a freddo + firme multiple + sistema di attacco DDOS ad alta protezione e altro architettura di trading per garantire la sicurezza degli asset del cliente. ",
    aboutdesc3:
      "Al fine di consentire ai clienti di cogliere meglio le opportunità di investimento, ntlex.com adotta una gestione piatta nel reparto di assistenza clienti e stabilisce un meccanismo di risposta del servizio estremamente rapido. Il responsabile del servizio clienti di asset è on-line 7 * 24 ore su 24 tutto l'anno round, fornendo ai clienti servizi come ricarica e contanti delle risorse e assicurando che i clienti completino la ricarica in 25 minuti. ",
    aboutdesc4:
      "ntlex.com controlla rigorosamente progetti di alta qualità e fornisce servizi di hosting di asset sicuri e stabili. ntlex.com sostiene il concetto di 'onestà, giustizia, entusiasmo e apertura' e si impegna a creare un ambiente sicuro, affidabile e scambio finale efficiente e amichevole per gli utenti. ",
    aboutdesc5:
      "Sebbene le risorse digitali siano solo in un circolo ristretto ora, crediamo che questo tipo di risorse che tutti possono comprendere appieno sarà popolare in futuro. Lavoriamo insieme e non vediamo l'ora!",
    aboutdesc6:
      "ntlex.com (Nano Token Liquidity) è un exchange di derivati di asset digitali internazionale basato sulla governance di un'organizzazione autonoma decentralizzata (DAO), con l'obiettivo di fornire ai suoi utenti globali un servizio di trading di asset blockchain sicuro, stabile, conveniente, equo e affidabile.",
    aboutdesc7:
      "NTL DAO affida la gestione di ntlex.com alla Fondazione delle Isole Cayman, che ha un vantaggio rispetto agli exchange di criptovalute tradizionali garantendo l'equità e la sicurezza degli asset degli utenti. I membri del team di gestione provengono da diversi paesi e regioni del mondo e i principali membri fondatori hanno lavorato in aziende finanziarie e tecnologiche di fama mondiale come Coinbase, Binance, Morgan Stanley, Amazon e Google, vantando una forte capacità di operare a livello globale e un'ampia esperienza nella gestione e nel controllo dei rischi finanziari.",
    aboutdesc8:
      "ntlex.com offre servizi di asset crittografici a tutto tondo, tra cui lo scambio di criptovalute, contratti perpetui, spot, opzioni, NFT, prestiti e investimenti, e supporta molte lingue tra cui cinese, inglese, giapponese e coreano. La sua soluzione tecnica si basa su piattaforme come Amazon AWS e Google Cloud, che possono prevenire attacchi DDOS e supportare funzionalità come la separazione dei dati dinamici e statici, la cache dei dati caldi, la ridondanza geografica, l'espansione parallela e altro ancora. L'architettura tecnologica leader a livello mondiale garantisce un trading sicuro per gli utenti, con la funzione di accesso immediato alle risorse di blockchain, la tecnologia di condivisione di indirizzi multi-valuta e una protezione di sicurezza multipla. Inoltre, ntlex.com ha commissioni di trading e di prelievo relativamente basse rispetto al settore degli asset blockchain.",
    aboutdesc9:
      "Come exchange di governance DAO degno di fiducia degli utenti, ntlex.com si impegna a garantire la sicurezza delle informazioni di trading degli utenti e degli asset, fornendo ai suoi utenti un'esperienza di trading eccellente.",
    support: 'Supporto',
    report: 'Suggerimento',
    service: 'Assistenza clienti',
    apply: 'Board Apply',
    coop: 'Cooperazione',
    community: 'Comunità NTL',
    wechat: 'Wechat',
    addwechat: "Aggiungi' bmate601 'come amici di Wechat e poi entra nella community di Wechat",
    weibo: 'Weibo',
    twitter: 'Twitter',
    biyong: 'Biyong',
    telegram: 'Telegram',
    medium: 'Medio',
    reddit: 'Reddit',
  },
  bzb_description: {
    title1: '',
    title2: '',
    title3: '',
    title4: '',
    title5: '',
    title6: '',
    title7: '',
    title8: '',
    desc1: '',
    desc2: '',
    desc3: '',
    desc4: '',
    desc5: '',
    desc6: '',
    desc7: '',
    desc8: '',
  },
  footer: {
    wechatkefu: 'servizio wechat',
    notice: 'Annuncio',
    gsmc: 'Global premium digital asset exchange',
    bah: 'N. 13026899 -3, Shanghai ICP',
    gsjj: 'Profilo',
    gywm: 'Riguardo a noi',
    jrwm: 'Unisciti a noi',
    biyong: 'BiYong',
    lxwm: 'Contattaci',
    yqlj: 'Collegamenti',
    bzzx: 'Aiuto',
    xsrm: 'Un corso per principianti',
    czzn: 'Guida alla ricarica',
    jyzn: 'Guida commerciale',
    ptsm: 'Spiega',
    fysm: 'Commissioni',
    fwtk: 'Politica di servizio',
    fltk: 'politica legale',
    wechat: 'Servizio clienti Wechat',
    xszn: 'Guida per principianti',
    cjwt: 'FAQ',
    mztk: 'Disclaimer',
    ystk: 'Politica sulla riservatezza',
    tkxy: 'Condizioni',
    gybzb: 'Informazioni su BZB',
    kfyx: 'Cassetta postale di servizio',
    swhz: 'Cooperazione',
    sbsq: 'Applicazione di mercato',
    bzzl: 'Informazioni sulla moneta',
    tsjb: 'Rapporto',
    apidoc: 'Api Doc',
    zwkf: 'Vieni presto',
  },
  index: {
    circulation: 'Circolazione dei fondi per la sicurezza e lo sviluppo',
    hourEth: 'Entrate cumulative da distribuire oggi',
    yesterdayEth: 'Entrate cumulative da distribuire ieri',
    yesterday: 'Produzione mineraria del giorno precedente:',
    bhbTotal: 'Flusso totale BHB',
    bhbSecond: 'BHB Circolazione del mercato a due livelli',
    checkMineprinciple: 'Visualizza il principio del mining',
    checkFlowVolum: 'Ispezione della circolazione',
    checkLockPosition: 'Controlla la situazione della serratura',
    BHBregister: 'Registrazione account NTL',
    tibi: 'Il tempo e il limite di pagamento del denaro in fattura',
    line_plane:
      'Annuncio sul piano on-line di BHB, circolazione e restituzione dei costi di servizio',
    fenpeijizhi: 'Una descrizione del meccanismo di distribuzione del reddito di NTL',
    jiangli_jihua: 'Inviting the mining Award Scheme',
    friend_fanhuan: 'Invita amici, guadagna una quota extra e torna indietro',
  },
  plate: {
    title:
      'Schema di distribuzione del reddito della piattaforma （Patrimonio del titolare di BHB）',
    content1:
      "Come descritto nel white paper, NTL occuperà l'80% della piattaforma (al netto di tasse e commissioni) Il reddito viene assegnato ai titolari di BHB e il 20% delle entrate viene utilizzato per supportare la ricerca e lo sviluppo e il funzionamento della piattaforma . ",
    content2:
      'La distribuzione del reddito richiede giorni come ciclo di distribuzione e il 6 giugno 2018 come primo giorno di distribuzione. Ogni giorno successivo, il reddito totale da distribuire il giorno precedente sarà distribuito in proporzione ai titolari di BHB.',
    content3:
      '（Avviso ： 1. Il BHB qui si riferisce solo al BHB che è stato rilasciato / fatto circolare. Vedi anche 【',
    content3_1:
      'Nota sul rapporto tra circolazione BHB / partecipazione alla distribuzione del reddito',
    content3_2:
      "2. l'istantanea oraria (punto intero) viene calcolata una volta e la distribuzione del reddito viene eseguita una volta al giorno.",
    hourFenpei: 'Distribuzione del reddito oggi',
    hourTotal: 'Reddito totale della piattaforma odierna',
    xiangqing: 'Dettagli della distribuzione del reddito odierna',
    yesterdaytit: 'Distribuzione del reddito ieri',
    yesterdaytotal: 'Entrate totali della piattaforma di ieri',
    yesterdayxiangqing: 'Dettagli della distribuzione del reddito di ieri',
    yesterday: {
      total: 'Ricavi totali',
      allocated: 'Ricavi non distribuiti',
    },
  },
  feereturn: {
    ruletitle: 'Nota',
    rulecontent:
      'Il nostro libro bianco contiene una spiegazione dettagliata del rimborso delle commissioni di transazione. Nel complesso, il 51% della base BHB totale della piattaforma' +
      "(denominata' porzione di ricompensa della comunità 'd'ora in poi) sarà rimborsato agli utenti nel tempo tramite il nostro meccanismo 'Trans-Fee Mining'. Tuttavia, una volta che questo 51% dei BHB totali sarà stato completamente rilasciato tramite rimborso, il meccanismo 'Trans-Fee Mining' terminerà automaticamente. ",
    recordtitle: 'Elenco',
    recordcontent:
      'Tutti i giorni (UTC + 8, come sotto) BHB rimborserà il 100% degli utenti' +
      'le commissioni di transazione sostenute dal giorno precedente sotto forma di BHB. Ciò sarà fatto utilizzando il prezzo medio BHB del giorno precedente (questo prezzo medio è calcolato come valore totale negoziato / volume totale negoziato). Completeremo questo rimborso delle commissioni di transazione dal giorno precedente sotto forma di BHB, alle 11:00 tutti i giorni. ',
    time: 'Data',
    todaycharge: 'Prezzo medio (ETH)',
    totalChange: 'Totale (ETH)',
    returnCharge: 'Trans-Fee Mining reimbursement (BHB)',
    todayChargeReturn: 'Programma di incentivi per il rimborso di FCoin （BHB）',
  },
};
